export const settings = {
  course_archive_progress: {
    Name: 'Archive Course Progress Dashboard',
    cat: 'Embeds',
    icon: 'chart-pie-simple',
    description: 'Display Courses Archive Status',
  },
  tableau: {
    Name: 'Tableau',
    icon: 'tv',
    description:
      'Allow for an Tableu Dashboard with a Provided Url to be Shown',
    cat: 'Embeds',
    defaults: {
      measure_of: 'pxs',
    },
    settings: [
      {
        label: 'Url',
        param: 'url',
        type: 'text',
      },
      {
        label: 'Configure Style',
        param: 'allow_style',
        type: 'checkbox',
      },
      {
        label: 'Height',
        param: 'height',
        type: 'number',
        if: [{ param: 'allow_style', value: true }],
      },
      {
        label: 'Width',
        param: 'width',
        type: 'number',
        if: [{ param: 'allow_style', value: true }],
      },
      {
        label: 'In Measurements Of',
        param: 'measure_of',
        if: [{ param: 'allow_style', value: true }],
        type: 'select',
        options: {
          Pixles: 'px',
          Percents: '%',
          REM: 'rem',
          ViewPort: 'vp',
        },
      },
    ],
  },
  email: {
    Name: 'Email',
    description:
      'Allow for an email to be sent with a subject and body to be provided',
    icon: 'arrow-right',
    cat: 'Embeds',
    settings: [
      {
        label: 'Email To',
        param: 'email_to',
        type: 'text',
        validate: /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/,
        invalidMessage: 'Invalid Email format.',
      },
    ],
  },
  heading: {
    Name: 'Heading',
    icon: 'heading',
    description: 'A text heading that can be set to various levels.',
    cat: 'Content',
    blacklist: ['key-write', 'key-read'],
    settings: [
      {
        label: 'Data Key',
        param: 'name',
        type: 'model',
      },
      {
        label: 'Heading Type',
        param: 'heading_type',
        type: 'select',
        options: {
          'Heading 1': 'h1',
          'Heading 2': 'h2',
          'Heading 3': 'h3',
          'Heading 4': 'h4',
          'Heading 5': 'h5',
          'Heading 6': 'h6',
        },
      },
      {
        label: 'Translation',
        param: 'translation_key',
        type: 'translation_key',
      },

      {
        label: 'Transform Text',
        param: 'text_transform',
        type: 'select',
        options: {
          Default: '',
          Capitalize: 'capitalize',
          Uppercase: 'uppercase',
        },
      },

      {
        label: 'Align',
        param: 'alignment',
        type: 'select',
        options: {
          Center: 'align-center',
          Left: 'align-left',
          Right: 'align-right',
        },
      },
    ],
  },
  break: {
    Name: 'Horizontal Rule',
    description: 'Horizontal line as a break in the page.',
    cat: 'Layout',
    blacklist: [
      'key-write',
      'key-read',
      { type: 'courses', key: 'target_lms', value: 'blackboard_ultra' },
    ],
  },
  icon: {
    Name: 'Icon',
    icon: 'icons',
    description: 'Display an icon.',
    cat: 'Content',
    blacklist: ['view', 'key-write', 'key-read'],
    settings: [
      {
        label: 'Icon',
        param: 'icon',
        type: 'icon',
      },
      {
        label: 'Color',
        param: 'color',
        type: 'color',
      },
      {
        label: 'Tooltip',
        param: 'title',
        type: 'text',
      },
      {
        label: 'Translation for Tooltip',
        param: 'translation_key',
        type: 'translation_key',
      },
      {
        label: 'Transform Text',
        param: 'text_transform',
        type: 'select',
        options: {
          Default: '',
          Capitalize: 'capitalize',
          Uppercase: 'uppercase',
        },
      },
    ],
  },
  data_table: {
    Name: 'Data Driven Table',
    icon: 'table',
    description:
      'Table for displaying data object list or properties of a single data object.',
    cat: 'Content',
    blacklist: ['view', 'key-write', 'key-read'],
    settings: [
      {
        label: 'Placement',
        param: 'data_source',
        type: 'select',
        options: {
          'List of Data Object': 'list',
          'Array of Data on Object': 'object',
        },
      },
      {
        label: 'Types to load',
        param: 'list_view',
        type: 'data_view',
        if: [{ param: 'data_source', value: 'list' }],
      },
      {
        label: 'No items Translation',
        param: 'no_items_translation',
        type: 'translation_key',
      },
      {
        label: 'Load Linked Items',
        param: 'linked',
        type: 'checkbox',
        if: [{ param: 'data_source', value: 'list' }],
      },
      {
        label: 'Allow Searching in List',
        param: 'allow_search',
        type: 'checkbox',
        if: [{ param: 'data_source', value: 'list' }],
      },
      {
        label: 'Avoid Paginating',
        param: 'avoid_paginating',
        type: 'checkbox',
        if: [{ param: 'data_source', value: 'list' }],
      },
      {
        label: 'Open Location',
        param: 'link_location',
        type: 'select',
        options: {
          'Main View': 'view',
          Dialog: 'modal',
        },
      },
      {
        label: 'Modal Width Size',
        type: 'select',
        if: [{ param: 'link_location', value: 'modal' }],
        options: {
          Wide: 'wide',
          Half: 'half',
          Fit: 'fit',
        },
        param: 'modal_width_size',
      },
      {
        label: 'Sort Initially On Field',
        param: 'allow_field_sort_init',
        type: 'checkbox',
        if: [{ param: 'data_source', value: 'list' }],
      },

      {
        label: 'Field to Sort Initially On',
        param: 'field_sort_init',
        type: 'key-select',
        if: [
          { param: 'allow_field_sort_init', value: true },
          { param: 'data_source', value: 'list' },
        ],
      },

      {
        label: 'Direction to Sort Intially On',
        param: 'field_sort_init_direction',
        type: 'select',
        if: [
          { param: 'allow_field_sort_init', value: true },
          { param: 'data_source', value: 'list' },
        ],
        options: {
          Ascending: 'ASC',
          Descending: 'DESC',
        },
      },

      {
        label: 'Autosave Modal on Close',
        param: 'autosave_modal',
        type: 'checkbox',
        if: [{ param: 'link_location', value: 'modal' }],
      },

      {
        label: 'Clickable Row to Link to Data',
        param: 'row_link',
        type: 'checkbox',
        if: [{ param: 'data_source', value: 'list' }],
      },

      {
        label: 'Transform Text',
        param: 'row  text_transform',
        type: 'select',
        options: {
          Default: '',
          "Capitalize Each Row's First Letter of Every Word": 'capitalize',
          'Uppercase All Rows': 'uppercase',
        },
      },

      {
        label: 'Display Active Item State Filter Dropdown',
        param: 'display_active_state_filter',
        type: 'checkbox',
        if: [{ param: 'data_source', value: 'list' }],
      },
      {
        label: 'Force Only Active Items To Be Searched',
        param: 'force_only_active_items',
        type: 'checkbox',
        if: [{ param: 'data_source', value: 'list' }],
      },

      {
        label: 'Initially Filter Data Based On Fields',
        param: 'filter_data',
        type: 'checkbox',
        if: [{ param: 'data_source', value: 'list' }],
      },

      {
        label: 'Fields to Filter On',
        param: 'filter_list_field',
        type: 'filter_values',
        if: [
          { param: 'filter_data', value: true },
          { param: 'data_source', value: 'list' },
        ],
      },

      {
        label: 'Wait for search to load items',
        param: 'search_load',
        type: 'checkbox',
        if: [
          { param: 'data_source', value: 'list' },
          { param: 'allow_search', value: true },
        ],
        help: `Items in this list will not be loaded until an active search is executed`,
      },
      {
        label: 'Hide Term Selection for Search',
        param: 'hide_terms',
        type: 'checkbox',
        if: [
          { param: 'data_source', value: 'list' },
          { param: 'allow_search', value: true },
        ],
      },
      {
        label: 'Allow Editing from List',
        param: 'allow_edit',
        type: 'checkbox',
        if: [{ param: 'data_source', value: 'list' }],
      },
      {
        label: 'Edit mode',
        param: 'edit_mode',
        type: 'text',
        if: [{ param: 'allow_edit', value: true }],
      },
      {
        label: 'Allow Deleting from List',
        param: 'allow_delete',
        type: 'checkbox',
        if: [{ param: 'data_source', value: 'list' }],
      },
      {
        label: 'Show Column Counts',
        param: 'allow_counts',
        type: 'checkbox',
        help: 'Show toggle for displaying count of each value in column',
        if: [{ param: 'data_source', value: 'list' }],
      },
      {
        label: 'Page Count',
        param: 'pageCounts',
        type: 'settings_array',
        if: [{ param: 'data_source', value: 'list' }],
        settings: [
          {
            label: 'Count',
            param: 'count',
            type: 'number',
          },
        ],
        defaults: {
          count: 10,
        },
      },
      {
        label: 'Use Contasting Row Backgrounds',
        param: 'use_contrast_background',
        type: 'checkbox',
      },
      {
        label: 'Column',
        param: 'columns',
        type: 'settings_array',
        if: [{ param: 'data_source', value: 'list' }],
        settings: [
          {
            label: 'Data Key',
            param: 'data',
            type: 'model',
            data_type: 'list_view',
          },
          {
            label: 'Label',
            param: 'label',
            type: 'text',
          },
          {
            label: 'Translation',
            param: 'translation_key',
            type: 'translation_key',
          },
          {
            label: 'Transform Text',
            param: 'text_transform',
            type: 'select',
            options: {
              Default: '',
              Capitalize: 'capitalize',
              Uppercase: 'uppercase',
            },
          },

          {
            label: 'Act as Link to Data',
            param: 'link',
            type: 'checkbox',
          },
          {
            label: 'Avoid as a SearchBy Option',
            param: 'avoid_search_by_option',
            type: 'checkbox',
          },
          {
            label: 'Default Value',
            param: 'default_value',
            type: 'checkbox',
          },
          {
            label: 'Hide column if all values are empty',
            param: 'no_null_value',
            type: 'checkbox',
          },
          {
            label: 'Default Value Text',
            param: 'default_value_text',
            type: 'text',
            if: [{ param: 'default_value', value: true }],
          },
          {
            label: 'Translation for Default',
            param: 'translation_key_default',
            type: 'translation_key',
            if: [{ param: 'default_value', value: true }],
          },
          {
            label: 'Default Value Style Grey',
            param: 'default_value_style_grey',
            type: 'checkbox',
            if: [{ param: 'default_value', value: true }],
          },

          {
            label: 'Default Value Style Italic',
            param: 'default_value_style_italic',
            type: 'checkbox',
            if: [{ param: 'default_value', value: true }],
          },
          {
            label: 'Map Value to Display Value',
            param: 'map_value',
            type: 'checkbox',
          },

          {
            label: 'Value to Map',
            param: 'values_to_map',
            type: 'map_values',
            if: [{ param: 'map_value', value: true }],
          },

          {
            label: 'Transform Text',
            param: 'text_transform',
            type: 'select',
            options: {
              Default: '',
              'Uppercase First Letter of Each Word': 'capitalize',
              'Uppercase Every Letter': 'uppercase',
            },
          },
          {
            label: 'Data Type',
            param: 'type',
            type: 'select',
            options: {
              Default: '',
              Date: 'date',
              'Date/Time': 'datetime',
              Percent: 'percent',
            },
          },
        ],
        defaults: {
          label: 'Column',
        },
      },
      {
        label: 'Data Key',
        param: 'name',
        type: 'model',
        if: [{ param: 'data_source', value: 'object' }],
      },
      {
        label: 'Column',
        param: 'columns',
        type: 'settings_array',
        if: [{ param: 'data_source', value: 'object' }],
        settings: [
          {
            label: 'Column Key',
            param: 'data',
            type: 'text',
          },
          {
            label: 'Label',
            param: 'label',
            type: 'text',
          },
          {
            label: 'Translation',
            param: 'translation_key',
            type: 'translation_key',
          },
          {
            label: 'Transform Text',
            param: 'text_transform',
            type: 'select',
            options: {
              Default: '',
              Capitalize: 'capitalize',
              Uppercase: 'uppercase',
            },
          },
          {
            label: 'Input Type',
            param: 'input_type',
            type: 'select',
            options: {
              None: 'none',
              Text: 'text',
              Number: 'number',
              Select: 'select',
            },
          },

          ,
          {
            label: 'Options',
            param: 'options',
            type: 'settings_array',
            if: [{ param: 'input_type', value: 'select' }],
            settings: [
              {
                label: 'Label',
                param: 'label',
                type: 'text',
              },
              {
                label: 'Translation',
                param: 'translation_key',
                type: 'translation_key',
              },
              {
                label: 'Transform Text',
                param: 'text_transform',
                type: 'select',
                options: {
                  Default: '',
                  Capitalize: 'capitalize',
                  Uppercase: 'uppercase',
                },
              },
              {
                label: 'Value',
                param: 'value',
                type: 'text',
              },
            ],
            defaults: {
              label: 'Column',
            },
          },
        ],
        defaults: {
          label: 'Column',
        },
      },
      {
        label: 'Options',
        param: 'options',
        type: 'settings_array',

        settings: [
          {
            label: 'Label',
            param: 'label',
            type: 'text',
          },
          {
            label: 'Value',
            param: 'value',
            type: 'text',
          },
        ],
        defaults: {
          label: 'Column',
        },
      },
    ],
  },
  table_like_columns: {
    Name: 'Configurable Table',
    icon: 'table',
    description:
      'Table for displaying view configuration for a list of data items',
    cat: 'Content',
    blacklist: ['view', 'key-write', 'key-read'],
    settings: [
      {
        label: 'Types to load',
        param: 'list_view',
        type: 'data_view',
      },
      {
        label: 'Column',
        param: 'columns',
        type: 'settings_array',
        settings: [
          {
            label: 'Label',
            param: 'label',
            type: 'text',
          },
          {
            label: 'Translation',
            param: 'translation_key',
            type: 'translation_key',
          },
          {
            label: 'Transform Text',
            param: 'text_transform',
            type: 'select',
            options: {
              Default: '',
              Capitalize: 'capitalize',
              Uppercase: 'uppercase',
            },
          },
          ,
          {
            label: 'Sort Key',
            param: 'name',
            type: 'model',
            data_type: 'list_view',
          },
        ],
        defaults: {
          label: 'Column',
          content: [],
        },
      },
      {
        label: 'Allow Searching in List',
        param: 'allow_search',
        type: 'checkbox',
      },

      {
        label: 'Display Active Item State Filter Dropdown',
        param: 'display_active_state_filter',
        type: 'checkbox',
      },
      {
        label: 'Force Only Active Items To Be Searched',
        param: 'force_only_active_items',
        type: 'checkbox',
      },

      {
        label: 'Wait for search to load items',
        param: 'search_load',
        type: 'checkbox',
        if: [{ param: 'allow_search', value: true }],
        help: `Items in this list will not be loaded until an active search is executed`,
      },
      {
        label: 'Hide Term Selection for Search',
        param: 'hide_terms',
        type: 'checkbox',
        if: [{ param: 'allow_search', value: true }],
      },
      {
        label: 'Page Count',
        param: 'pageCounts',
        type: 'settings_array',
        if: [{ param: 'data_source', value: 'list' }],
        settings: [
          {
            label: 'Count',
            param: 'count',
            type: 'number',
          },
        ],
        defaults: {
          count: 10,
        },
      },
      {
        label: 'Use Contasting Row Backgrounds',
        param: 'use_contrast_background',
        type: 'checkbox',
      },
    ],
  },

  youtube: {
    Name: 'YouTube',
    icon: 'film',
    description:
      'Embed a YouTube video that will resize to fit the available screen size.',
    cat: 'Embeds',
    settings: [
      {
        label: 'Size',
        param: 'size',
        type: 'select',
        options: {
          Small: 'embed-media-sm',
          Medium: 'embed-media-md',
          Large: 'embed-media-lg',
        },
      },
      {
        label: 'Video id',
        param: 'video',
        type: 'text',
      },
      {
        label: 'YouTube URL',
        param: 'video',
        type: 'youtube_url',
      },
    ],
  },
  iframe: {
    Name: 'Iframe Embed',
    icon: 'portrait',
    description:
      'Embed an external tool in an iframe that will resize to fit the available screen size.',
    cat: 'Embeds',
    blacklist: ['key-write', 'key-read'],
    settings: [
      {
        label: 'URL',
        param: 'url',
        type: 'text',
      },
      {
        label: 'Size',
        param: 'size',
        type: 'select',
        options: {
          Small: 'embed-media-sm',
          Medium: 'embed-media-md',
          Large: 'embed-media-lg',
        },
      },
    ],
  },
  //

  datax_select_role: {
    Name: 'Datax Select Role',
    icon: 'file-image',
    description: 'Select a Role from the list of current Datax Roles',
    cat: 'Inputs',
    blacklist: ['view', 'key-write', 'key-read'],
    settings: [
      {
        label: 'Parameter',
        param: 'name',
        type: 'model',
      },
      {
        label: 'Label',
        param: 'label',
        type: 'text',
      },
      {
        label: 'Required',
        param: 'required',
        type: 'boolean',
      },
    ],
  },

  //
  file_image: {
    Name: 'File Select',
    icon: 'file-image',
    description: 'File select input.',
    cat: 'Inputs',
    blacklist: ['view', 'key-write', 'key-read'],
    settings: [
      {
        label: 'Parameter',
        param: 'name',
        type: 'model',
      },
      {
        label: 'Select Button Label',
        param: 'label',
        type: 'text',
      },
      ,
      {
        label: 'Translation For Select Label',
        param: 'translation_key_select_label',
        type: 'translation_key',
      },
      {
        label: 'Transform Text For Select Label',
        param: 'text_transform_select_label',
        type: 'select',
        options: {
          Default: '',
          Capitalize: 'capitalize',
          Uppercase: 'uppercase',
        },
      },
      {
        label: 'Clear Button Label',
        param: 'clear_label',
        type: 'text',
      },
      {
        label: 'Translation For Clear Label',
        param: 'translation_key_clear_label',
        type: 'translation_key',
      },
      {
        label: 'Transform Text For Clear Label',
        param: 'text_transform_clear_label',
        type: 'select',
        options: {
          Default: '',
          Capitalize: 'capitalize',
          Uppercase: 'uppercase',
          Lowercase: 'lowercase',
        },
      },

      {
        label: 'File Type',
        param: 'file_type',
        type: 'select',
        options: {
          Any: '',
          Image: 'image',
        },
      },
    ],
  },
  image: {
    Name: 'Image',
    icon: 'image',
    description: 'Embed an image.',
    cat: 'Embeds',
    settings: [
      {
        label: 'Data Key',
        param: 'name',
        type: 'model',
      },
      {
        label: 'File',
        param: 'file',
        type: 'file_image',
      },
      {
        label: 'Allow Selecting in Template',
        param: 'allow_file_select',
        type: 'checkbox',
        if: [{ param: 'name', defined: true }],
      },
      {
        label: 'Template Image Title',
        param: 'image_title',
        type: 'text',
        if: [{ param: 'name', defined: true }],
      },
      {
        label: 'Clear Button Label',
        param: 'clear_label',
        type: 'text',
        if: [
          { param: 'name', defined: true },
          { param: 'allow_file_select', defined: true },
        ],
      },
      {
        label: 'Image URL',
        param: 'url',
        type: 'text',
      },
      {
        label: 'Description(Alt text)',
        param: 'text',
        type: 'text',
      },
      {
        label: 'Translation',
        param: 'translation_key',
        type: 'translation_key',
      },
      {
        label: 'Transform Text',
        param: 'text_transform',
        type: 'select',
        options: {
          Default: '',
          Capitalize: 'capitalize',
          Uppercase: 'uppercase',
          Lowercase: 'lowercase',
        },
      },

      {
        label: 'Width',
        param: 'width',
        type: 'number',
      },
      {
        label: 'Height',
        param: 'height',
        type: 'number',
      },
    ],
  },
  courseimage: {
    icon: 'image',
    Name: 'Course Image',
    description: 'Embed an image.',
    cat: 'Embeds',
    blacklist: ['view', 'key-write'],
    settings: [
      {
        label: 'Data Key',
        param: 'name',
        type: 'model',
      },
      {
        label: 'File',
        param: 'file',
        type: 'file_image',
      },
      {
        label: 'Image URL',
        param: 'url',
        type: 'text',
      },
      {
        label: 'Description',
        param: 'text',
        type: 'text',
      },
      {
        label: 'Width',
        param: 'width',
        type: 'number',
      },
      {
        label: 'Height',
        param: 'height',
        type: 'number',
      },
      {
        label: 'Trim to Height',
        param: 'landscape',
        type: 'checkbox',
      },
    ],
  },
  outcomesedit: {
    Name: 'Outcomes',
    icon: 'th-list',
    description: 'Edit course outcomes.',
    cat: 'Inputs',
    blacklist: ['view', 'key-write', 'key-read'],
    settings: [
      {
        label: 'Data Key',
        param: 'name',
        type: 'model',
      },
      {
        label: 'Capitalize Verbs',
        param: 'verb_capitalize',
        type: 'checkbox',
      },
      {
        label: 'Outcome Label',
        param: 'outcome_label',
        type: 'text',
        help: 'Example: Outcomes, Objectives Etc.',
      },
      {
        label: 'Translation',
        param: 'translation_key',
        type: 'translation_key',
      },
      {
        label: 'Transform Text',
        param: 'text_transform',
        type: 'select',
        options: {
          Default: '',
          Capitalize: 'capitalize',
          Uppercase: 'uppercase',
          Lowercase: 'lowercase',
        },
      },
    ],
  },
  labeled_text: {
    Name: 'Labeled Text',
    icon: 'tags',
    description: 'Text display for a property with a label.',
    cat: 'Content',
    blacklist: ['view', 'key-write'],
    settings: [
      {
        label: 'Data Key',
        param: 'name',
        type: 'model',
      },
      {
        label: 'Label',
        param: 'label',
        type: 'text',
      },
      {
        label: 'Translation',
        param: 'translation_key',
        type: 'translation_key',
      },
      {
        label: 'Transform Text',
        param: 'text_transform',
        type: 'select',
        options: {
          Default: '',
          Capitalize: 'capitalize',
          Uppercase: 'uppercase',
          Lowercase: 'lowercase',
        },
      },
    ],
  },
  text: {
    Name: 'Rich Text Content',
    icon: 'paragraph',
    description: 'A block of text with rich formatting options.',
    cat: 'Content',
    defaults: {
      text_transform: '',
    },
    settings: [
      {
        label: 'Data Key',
        param: 'name',
        type: 'model',
      },
      {
        label: 'Truncate Text',
        param: 'truncate',
        type: 'checkbox',
      },

      {
        label: 'Transform Text',
        param: 'text_transform',
        type: 'select',
        options: {
          Default: '',
          Capitalize: 'capitalize',
          Uppercase: 'uppercase',
          Lowercase: 'lowercase',
        },
      },

      {
        label: 'Space above/below (plain text only)',
        param: 'text_margin',
        type: 'number',
      },
    ],
  },
  button: {
    Name: 'Event Button',
    description:
      'A button that can be set to trigger a specific event related to an item.',
    icon: 'dot-circle',
    cat: 'Inputs',
    blacklist: ['view', 'key-write', 'key-read'],
    settings: [
      {
        label: 'Label',
        param: 'label',
        type: 'text',
      },
      {
        label: 'Translation',
        param: 'translation_key',
        type: 'translation_key',
      },
      {
        label: 'Transform Text',
        param: 'text_transform',
        type: 'select',
        options: {
          Default: '',
          Capitalize: 'capitalize',
          Uppercase: 'uppercase',
          Lowercase: 'lowercase',
        },
      },

      {
        label: 'Operation',
        param: 'operation',
        type: 'select',
        options: {
          View: 'openRead',
          Settings: 'openSettings',
          Duplicate: 'duplicateItem',
          Move: 'openMove',
          Preview: 'preview',
          Delete: 'deleteData',
          Export: 'export',
        },
      },
      {
        label: 'Dialog Title',
        param: 'name',
        type: 'text',
        if: [{ param: 'operation', value: 'preview' }],
      },
      {
        label: 'Use Icon for Button',
        param: 'use_icon',
        type: 'checkbox',
      },
      {
        label: 'Use Text With Icon Instead of as Tooltip',
        param: 'use_icon_with_text',
        type: 'checkbox',
        if: [{ param: 'use_icon', value: true }],
      },
      {
        label: 'Icon',
        param: 'icon',
        type: 'icon',
        if: [{ param: 'use_icon', value: true }],
      },
    ],
  },
  input: {
    Name: 'Inputs',
    icon: 'i-cursor',
    description:
      'Allows inputing data that can be bound to a propert. Supports single line and rich text.',
    cat: 'Inputs',
    blacklist: ['view', 'key-read'],
    settings: [
      {
        label: 'Data Key',
        param: 'name',
        type: 'model',
      },
      {
        label: 'Label',
        param: 'label',
        type: 'text',
      },
      {
        label: 'Translation For Label',
        param: 'translation_key_label',
        type: 'translation_key',
      },
      {
        label: 'Transform Text For Label',
        param: 'text_transform_label',
        type: 'select',
        options: {
          Default: '',
          Capitalize: 'capitalize',
          Uppercase: 'uppercase',
          Lowercase: 'lowercase',
        },
      },

      {
        label: 'Placeholder Text',
        param: 'no_content_text',
        type: 'text',
      },
      {
        label: 'Default Value',
        param: 'default',
        type: 'text',
      },
      {
        label: 'Input Type',
        param: 'input_type',
        type: 'select',
        options: {
          Text: 'text',
          Number: 'number',
          'Rich Text': 'textarea',
          'Plain Text': 'plaintextarea',
        },
      },
      {
        label: 'Placeholder Text',
        param: 'no_content_text',
        type: 'text',
        if: [{ param: 'input_type', value: 'textarea' }],
      },

      {
        label: 'Translation For Placeholder',
        param: 'translation_key_placeholder',
        type: 'translation_key',
      },
      {
        label: 'Transform Text For Placeholder',
        param: 'text_transform_placeholder',
        type: 'select',
        options: {
          Default: '',
          Capitalize: 'capitalize',
          Uppercase: 'uppercase',
          Lowercase: 'lowercase',
        },
      },

      {
        label: 'Show Editor Frame',
        param: 'block_editor',
        type: 'checkbox',
        if: [{ param: 'input_type', value: 'textarea' }],
      },
      {
        label: 'Hide formatting controls',
        param: 'hide_editor_ui',
        type: 'checkbox',
        if: [
          { param: 'input_type', value: 'textarea' },
          { param: 'block_editor', value: 'false' },
        ],
      },
      {
        label: 'Help Text',
        param: 'helpText',
        type: 'text',
      },

      {
        label: 'Translation For Help Text',
        param: 'translation_key_help',
        type: 'translation_key',
      },
      {
        label: 'Transform Text for Help Text',
        param: 'text_transform_help',
        type: 'select',
        options: {
          Default: '',
          Capitalize: 'capitalize',
          Uppercase: 'uppercase',
          Lowercase: 'lowercase',
        },
      },

      {
        label: 'Validation Regex',
        param: 'validate',
        help: "A regular expression used for validating value of th input. Only used for 'Text' type.",
        type: 'text',
        if: [{ param: 'input_type', value: 'text' }],
      },
      {
        label: 'Invalid Message Text',
        param: 'invalid',
        help: "The message that will display if the input text doesn't match the validation requirement.",
        type: 'text',
      },

      {
        label: 'Translation For Invalid Text',
        param: 'translation_key_invalid',
        type: 'translation_key',
      },
      {
        label: 'Transform Text',
        param: 'text_transform_invalid',
        type: 'select',
        options: {
          Default: '',
          Capitalize: 'capitalize',
          Uppercase: 'uppercase',
          Lowercase: 'lowercase',
        },
      },

      {
        label: 'Step Size',
        param: 'step',
        type: 'text',
        help: 'The smallest valid increment for the input. For the number 2.71, a valid step setting would be 0.01',
        if: [{ param: 'input_type', value: 'number' }],
      },
      {
        label: 'Min',
        param: 'min',
        type: 'text',
        if: [{ param: 'input_type', value: 'number' }],
      },
      {
        label: 'Max',
        param: 'max',
        type: 'text',
        if: [{ param: 'input_type', value: 'number' }],
      },
      {
        label: 'Set Height',
        param: 'min_height',
        type: 'text',
      },
      {
        label: 'Required',
        param: 'required',
        type: 'checkbox',
      },
    ],
  },
  edit_text: {
    Name: 'Editable Text',
    icon: 'pencil-alt',
    description: 'Displays a text value the can be edited by clicking on it.',
    cat: 'Inputs',
    blacklist: ['view', 'key-read'],
    settings: [
      {
        label: 'Data Key',
        param: 'name',
        type: 'model',
      },
      {
        label: 'Label',
        param: 'label',
        type: 'text',
      },
      {
        label: 'Translation For Label',
        param: 'translation_key_label',
        type: 'translation_key',
      },
      {
        label: 'Transform Text For Label',
        param: 'text_transform_label',
        type: 'select',
        options: {
          Default: '',
          Capitalize: 'capitalize',
          Uppercase: 'uppercase',
          Lowercase: 'lowercase',
        },
      },

      {
        label: 'Display Text As',
        param: 'display_type',
        type: 'select',
        options: {
          'Plain Text': 'p',
          'Heading 1': 'h1',
          'Heading 2': 'h2',
          'Heading 3': 'h3',
          'Heading 4': 'h4',
          'Heading 5': 'h5',
          'Heading 6': 'h6',
        },
      },
      {
        label: 'Default Value',
        param: 'default',
        type: 'text',
      },
      {
        label: 'Help Text',
        param: 'helpText',
        type: 'text',
      },
      {
        label: 'Validation Regex',
        param: 'validate',
        help: "A regular expression used for validating value of th input. Only used for 'Text' type.",
        type: 'text',
        if: [{ param: 'input_type', value: 'text' }],
      },
      {
        label: 'Invalid Message Text',
        param: 'invalid',
        help: "The message that will display if the input text doesn't match the validation requirement.",
        type: 'text',
      },
      {
        label: 'Required',
        param: 'required',
        type: 'checkbox',
      },
    ],
  },
  data_import: {
    Name: 'Data Import',
    icon: 'file-import',
    description: 'Allows importing data from various formats.',
    cat: 'Inputs',
    blacklist: ['view', 'key-read', 'key-write'],
    settings: [
      {
        label: 'Label',
        param: 'label',
        type: 'text',
      },
      {
        label: 'Translation for Label',
        param: 'translation_key_label',
        type: 'translation_key',
      },
      {
        label: 'Transform Text For Label',
        param: 'text_transform_label',
        type: 'select',
        options: {
          Default: '',
          Capitalize: 'capitalize',
          Uppercase: 'uppercase',
          Lowercase: 'lowercase',
        },
      },

      {
        label: 'Instructions',
        param: 'instructions',
        type: 'text',
      },
      {
        label: 'Translation for Instructions',
        param: 'translation_key_instructions',
        type: 'translation_key',
      },
      {
        label: 'Transform Text For Instructions',
        param: 'text_transform_instructions',
        type: 'select',
        options: {
          Default: '',
          Capitalize: 'capitalize',
          Uppercase: 'uppercase',
          Lowercase: 'lowercase',
        },
      },

      {
        label: 'Input Format',
        param: 'format',
        type: 'select',
        options: {
          'LTI XML': 'lti',
        },
      },
    ],
  },
  hidden_default: {
    Name: 'Hidden Default',
    icon: 'eye-slash',
    description: 'Allows adding a default value without a visible input.',
    cat: 'Inputs',
    blacklist: ['view', 'key-read'],
    settings: [
      {
        label: 'Data Key',
        param: 'name',
        type: 'model',
      },
      {
        label: 'Default Value',
        param: 'default',
        type: 'text',
      },
    ],
  },
  comments: {
    Name: 'Comment Section',
    icon: 'comments',
    description: 'Add a comment area to a view.',
    cat: 'Inputs',
    blacklist: ['view', 'key-read'],
    settings: [
      {
        label: 'Data Key',
        param: 'name',
        type: 'model',
      },
    ],
  },
  date_display: {
    Name: 'Date Display',
    icon: 'calendar-day',
    description:
      'Allows for displaying a formatted date and time that can be bound to a property.',
    cat: 'Content',
    blacklist: ['view', 'key-read'],
    settings: [
      {
        label: 'Data Key',
        param: 'name',
        type: 'model',
      },
      {
        label: 'Format',
        param: 'date_format',
        type: 'text',
      },
      {
        label: 'Display Set Timezone',
        param: 'show_timezone',
        type: 'checkbox',
      },
      {
        label: 'Display Local Time Note',
        param: 'display_local',
        type: 'checkbox',
      },
      {
        label: 'Extra Data',
        param: 'data',
        type: 'settings_array',
        settings: [
          {
            label: 'Data Key',
            param: 'name',
            type: 'model',
          },
        ],
        defaults: {},
      },
    ],
  },
  date: {
    Name: 'Date Picker',
    icon: 'calendar-day',
    description:
      'Allows for inputing a date and time that can be bound to a property.',
    cat: 'Inputs',
    blacklist: ['view', 'key-read'],
    settings: [
      {
        label: 'Data Key',
        param: 'name',
        type: 'model',
      },
      {
        label: 'Label',
        param: 'label',
        type: 'text',
      },
      {
        label: 'Translation for Label',
        param: 'translation_key_label',
        type: 'translation_key',
      },
      {
        label: 'Transform Text For Label',
        param: 'text_transform_label',
        type: 'select',
        options: {
          Default: '',
          Capitalize: 'capitalize',
          Uppercase: 'uppercase',
          Lowercase: 'lowercase',
        },
      },

      {
        label: 'Help Text',
        param: 'helpText',
        type: 'text',
      },
      {
        label: 'Translation for Help Text',
        param: 'translation_key_help_text',
        type: 'translation_key',
      },
      {
        label: 'Transform Text For Help',
        param: 'text_transform_help_text',
        type: 'select',
        options: {
          Default: '',
          Capitalize: 'capitalize',
          Uppercase: 'uppercase',
          Lowercase: 'lowercase',
        },
      },

      {
        label: 'Disable Time Component',
        param: 'hide_time',
        type: 'checkbox',
      },
      {
        label: '24 Hour Time',
        param: 'full_hours',
        type: 'checkbox',
      },
      {
        label: 'Extra Data',
        param: 'data',
        type: 'settings_array',
        settings: [
          {
            label: 'Data Key',
            param: 'name',
            type: 'model',
          },
        ],
        defaults: {},
      },
      {
        label: 'Required',
        param: 'required',
        type: 'checkbox',
      },
    ],
  },
  weekday: {
    Name: 'Day of the Week Picker',
    icon: 'calendar-week',
    description:
      'Allows for inputting day of the week or range of days without a specific date.',
    cat: 'Inputs',
    blacklist: ['view', 'key-read'],
    settings: [
      {
        label: 'Data Key',
        param: 'name',
        type: 'model',
      },
    ],
  },
  check: {
    Name: 'Checkbox',
    icon: 'check',
    description: 'A check box that can be bound to a true/false property.',
    cat: 'Inputs',
    blacklist: ['view', 'key-read'],
    settings: [
      {
        label: 'Data Key',
        param: 'name',
        type: 'model',
      },
      {
        label: 'Label',
        param: 'label',
        type: 'text',
      },
      {
        label: 'Translation for Label',
        param: 'translation_key_label',
        type: 'translation_key',
      },
      {
        label: 'Transform Text for Label',
        param: 'text_transform_label',
        type: 'select',
        options: {
          Default: '',
          Capitalize: 'capitalize',
          Uppercase: 'uppercase',
          Lowercase: 'lowercase',
        },
      },

      {
        label: 'Help Text',
        param: 'helpText',
        type: 'text',
      },
      {
        label: 'Translation for Help Text',
        param: 'translation_key_help_text',
        type: 'translation_key',
      },
      {
        label: 'Transform Text for Help Text',
        param: 'text_transform_help_text',
        type: 'select',
        options: {
          Default: '',
          Capitalize: 'capitalize',
          Uppercase: 'uppercase',
          Lowercase: 'lowercase',
        },
      },

      {
        label: 'Default Value',
        param: 'default',
        type: 'text',
      },
    ],
  },
  radio: {
    Name: 'Radio Buttons',
    icon: 'list-ul',
    description:
      'A radio button input with customizable options that can be bound to a property.',
    cat: 'Inputs',
    blacklist: ['view', 'key-read'],
    settings: [
      {
        label: 'Data Key',
        param: 'name',
        type: 'model',
      },
      {
        label: 'Label',
        param: 'label',
        type: 'text',
      },
      ,
      {
        label: 'Translation for Label',
        param: 'translation_key_label',
        type: 'translation_key',
      },
      {
        label: 'Transform Text for Label',
        param: 'text_transform_label',
        type: 'select',
        options: {
          Default: '',
          Capitalize: 'capitalize',
          Uppercase: 'uppercase',
          Lowercase: 'lowercase',
        },
      },

      {
        label: 'Direction',
        param: 'direction',
        type: 'select',
        options: {
          Horizontal: 'horizontal',
          Vertical: 'vertical',
        },
      },
      {
        label: 'Option',
        param: 'options',
        type: 'settings_array',
        settings: [
          {
            label: 'Label',
            param: 'label',
            type: 'text',
          },
          {
            label: 'Translation for Label',
            param: 'translation_key_label_option',
            type: 'translation_key',
          },

          {
            label: 'Transform Text for Label',
            param: 'text_transform_label_option',
            type: 'select',
            options: {
              Default: '',
              'Uppercase First Letter of Each Word': 'capitalize',
              'Uppercase Every Letter': 'uppercase',
            },
          },

          {
            label: 'Value',
            param: 'value',
            type: 'text',
          },
        ],
        defaults: {
          heading: 'Option',
        },
      },
      {
        label: 'Help Text',
        param: 'helpText',
        type: 'text',
      },
      {
        label: 'Translation for Help Text',
        param: 'translation_key_help_text',
        type: 'translation_key',
      },
      {
        label: 'Transform Text for Help Text',
        param: 'text_transform_help_text',
        type: 'select',
        options: {
          Default: '',
          Capitalize: 'capitalize',
          Uppercase: 'uppercase',
          Lowercase: 'lowercase',
        },
      },
    ],
  },
  select: {
    Name: 'Select List',
    icon: 'hand-pointer',
    description:
      'A selection input with customizable options that can be bound to a property.',
    cat: 'Inputs',
    blacklist: ['view', 'key-read'],
    settings: [
      {
        label: 'Data Key',
        param: 'name',
        type: 'model',
      },
      {
        label: 'Label',
        param: 'label',
        type: 'text',
      },
      {
        label: 'Translation for Label',
        param: 'translation_key_label',
        type: 'translation_key',
      },
      {
        label: 'Transform Text for Label',
        param: 'text_transform_label',
        type: 'select',
        options: {
          Default: '',
          Capitalize: 'capitalize',
          Uppercase: 'uppercase',
          Lowercase: 'lowercase',
        },
      },

      {
        label: 'Option',
        param: 'options',
        type: 'settings_array',
        settings: [
          {
            label: 'Label',
            param: 'label',
            type: 'text',
          },
          {
            label: 'Translation for Label',
            param: 'translation_key_label',
            type: 'translation_key',
          },
          {
            label: 'Transform Text for Label',
            param: 'text_transform_label',
            type: 'select',
            options: {
              Default: '',
              'Uppercase First Letter of Each Word': 'capitalize',
              'Uppercase Every Letter': 'uppercase',
            },
          },

          {
            label: 'Option Group',
            param: 'is_group',
            type: 'checkbox',
          },
          {
            label: 'Value',
            param: 'value',
            type: 'text',
            if: [{ param: 'is_group', value: false, not_defined: true }],
          },
          {
            label: 'Option',
            param: 'options',
            type: 'settings_array',
            if: [{ param: 'is_group', value: true }],
            settings: [
              {
                label: 'Label',
                param: 'label',
                type: 'text',
              },
              {
                label: 'Translation for Label',
                param: 'translation_key_label',
                type: 'translation_key',
              },
              {
                label: 'Transform Text for Label',
                param: 'text_transform_label',
                type: 'select',
                options: {
                  Default: '',
                  'Uppercase First Letter of Each Word': 'capitalize',
                  'Uppercase Every Letter': 'uppercase',
                },
              },

              {
                label: 'Value',
                param: 'value',
                type: 'text',
              },
            ],
            defaults: {
              heading: 'Option',
            },
          },
        ],
        defaults: {
          heading: 'Option',
        },
      },
      {
        label: 'Template Driven List',
        param: 'template_select',
        type: 'checkbox',
      },
      {
        label: 'Template Parameter',
        param: 'template_name',
        type: 'model',
      },
      {
        label: 'Help Text',
        param: 'helpText',
        type: 'text',
      },
      {
        label: 'Translation for Help Text',
        param: 'translation_key_help_text',
        type: 'translation_key',
      },
      {
        label: 'Transform Text for Help Text',
        param: 'text_transform_help_text',
        type: 'select',
        options: {
          Default: '',
          Capitalize: 'capitalize',
          Uppercase: 'uppercase',
          Lowercase: 'lowercase',
        },
      },

      {
        label: 'Required',
        param: 'required',
        type: 'checkbox',
      },
    ],
  },
  select_list_display: {
    Name: 'Select List Display',
    icon: 'tv',
    description:
      'A selection input with customizable options that can be bound to a property.',
    cat: 'Content',
    blacklist: ['view', 'key-write'],
    settings: [
      {
        label: 'Data Key',
        param: 'name',
        type: 'model',
      },
      {
        label: 'Display Option',
        param: 'options',
        type: 'settings_array',
        settings: [
          {
            label: 'Label',
            param: 'label',
            type: 'text',
          },
          {
            label: 'Translation',
            param: 'translation_key',
            type: 'translation_key',
          },
          {
            label: 'Transform Text',
            param: 'text_transform',
            type: 'select',
            options: {
              Default: '',
              'Uppercase First Letter of Each Word': 'capitalize',
              'Uppercase Every Letter': 'uppercase',
            },
          },

          {
            label: 'Value',
            param: 'value',
            type: 'text',
          },
        ],
        defaults: {
          heading: 'Option',
        },
      },
    ],
  },
  switch: {
    Name: 'Switch Input',
    icon: 'toggle-off',
    description: 'A switch input that can be bound to a true/false property.',
    cat: 'Inputs',
    blacklist: ['view', 'key-read'],
    settings: [
      {
        label: 'Data Key',
        param: 'name',
        type: 'model',
      },
      {
        label: 'Label',
        param: 'label',
        type: 'text',
      },
      {
        label: 'Translation for Label',
        param: 'translation_key_label',
        type: 'translation_key',
      },
      {
        label: 'Transform Text for Label',
        param: 'text_transform_label',
        type: 'select',
        options: {
          Default: '',
          Capitalize: 'capitalize',
          Uppercase: 'uppercase',
          Lowercase: 'lowercase',
        },
      },

      {
        label: 'Default Value',
        param: 'default',
        type: 'select',
        options: { True: true, False: false },
      },
      {
        label: 'Help Text',
        param: 'helpText',
        type: 'text',
      },
      {
        label: 'Translation for Help Text',
        param: 'translation_key_help',
        type: 'translation_key',
      },
      {
        label: 'Transform Text',
        param: 'text_transform_help',
        type: 'select',
        options: {
          Default: '',
          Capitalize: 'capitalize',
          Uppercase: 'uppercase',
          Lowercase: 'lowercase',
        },
      },
      {
        label: 'Ignore Prevent Edit',
        param: 'ignore_prevent_edit',
        type: 'checkbox',
        help: 'If checked, the switch will be enabled even if the user has prevent edit enabled.',
      },
    ],
  },
  carousel: {
    Name: 'Carousel',
    icon: 'crown',
    description: 'An image slideshow with captions.',
    cat: 'Embeds',
    blacklist: [
      'key-write',
      'key-read',
      { type: 'courses', key: 'target_lms', value: 'blackboard_ultra' },
    ],
    settings: [
      {
        label: 'Slide',
        param: 'slides',
        type: 'settings_array',
        settings: [
          {
            label: 'Image URL',
            param: 'url',
            type: 'text',
          },
          {
            label: 'Caption',
            param: 'caption',
            type: 'text',
          },
        ],
        defaults: {},
      },
    ],
  },
  template: {
    Name: 'Text Template',
    icon: 'layer-group',
    description: 'Create a line of text combining static text and data values.',
    cat: 'Content',
    blacklist: ['view', 'key-write', 'key-read'],
    settings: [
      {
        label: 'Template Display',
        param: 'display_type',
        type: 'select',
        options: {
          'Plain Text': 'p',
          Label: 'label',
          'Heading 1': 'h1',
          'Heading 2': 'h2',
          'Heading 3': 'h3',
          'Heading 4': 'h4',
          'Heading 5': 'h5',
          'Heading 6': 'h6',
        },
      },
      {
        label: 'Text Color',
        param: 'text_color',
        type: 'color',
        help: 'Accepts hex code "#123456"',
      },
      {
        label: 'Font Family',
        param: 'text_font_family',
        type: 'select',
        options: {
          Roboto: 'Roboto, sans-serif',
          Montserrat: 'Montserrat, sans-serif',
          'San Serif': 'sans-serif',
        },
      },
      {
        label: 'Font Size',
        param: 'text_font_size',
        type: 'select',
        options: {
          10: 10,
          11: 11,
          12: 12,
          13: 13,
          14: 14,
          15: 15,
          16: 16,
          17: 17,
          18: 18,
          19: 19,
          20: 20,
          21: 21,
          22: 22,
          23: 23,
          24: 24,
          25: 25,
          26: 26,
          27: 27,
          28: 28,
          29: 29,
          30: 30,
          31: 31,
          32: 32,
          33: 33,
          34: 34,
          35: 35,
          36: 36,
          37: 37,
          38: 38,
          39: 39,
          40: 40,
          41: 41,
          42: 42,
          43: 43,
          44: 44,
          45: 45,
          46: 46,
          47: 47,
          48: 48,
          49: 49,
          50: 50,
          51: 51,
          52: 52,
          53: 53,
          54: 54,
        },
      },

      {
        label: 'Font Weight',
        param: 'text_font_weight',
        type: 'select',
        options: {
          normal: 'normal',
          '100': '100',
          '200': '200',
          '300': '300',
          '400': '400',
          '500': '500',
          '600': '600',
          '700': '700',
          '800': '800',
          '900': '900',
        },
      },
      {
        label: 'Font Style',
        param: 'text_style',
        type: 'select',
        options: {
          normal: 'normal',
          italic: 'italic',
        },
      },

      {
        label: 'Template Item',
        param: 'content',
        type: 'settings_array',
        settings: [
          {
            label: 'Template Type',
            param: 'input_type',
            type: 'select',
            options: {
              Data: 'data',
              'Static Text': 'text',
              'Day of the Week Display': 'day_array',
              'File Size': 'filesize',
              'Line Break': 'break',
              Percent: 'percent',
            },
          },
          {
            label: 'Text',
            param: 'text',
            type: 'text',
            if: [{ param: 'input_type', value: 'text' }],
          },
          {
            label: 'Translation',
            param: 'translation_key',
            type: 'translation_key',
            if: [{ param: 'input_type', value: 'text' }],
          },
          {
            label: 'Transform Text',
            param: 'text_transform',
            type: 'select',
            if: [{ param: 'input_type', value: 'text' }],
            options: {
              Default: '',
              Capitalize: 'capitalize',
              Uppercase: 'uppercase',
              Lowercase: 'lowercase',
            },
          },
          {
            label: 'Text',
            param: 'text',
            type: 'text',
            if: [{ param: 'input_type', value: 'percent' }],
          },
          {
            label: 'Day Separator',
            param: 'seperator',
            type: 'text',
            if: [{ param: 'input_type', value: 'day_array' }],
          },
          {
            label: 'Data Key',
            param: 'name',
            type: 'model',
            if: [{ param: 'input_type', value: 'day_array' }],
          },
          {
            label: 'Use Day Numbers',
            param: 'use_numbers',
            type: 'checkbox',
            if: [{ param: 'input_type', value: 'day_array' }],
          },
          {
            label: 'Data Key',
            param: 'name',
            type: 'model',
            if: [{ param: 'input_type', value: 'data' }],
          },
          {
            label: 'Data Key',
            param: 'name',
            type: 'model',
            if: [{ param: 'input_type', value: 'filesize' }],
          },
        ],
        defaults: {},
      },
      {
        label: 'Store Output in Variable',
        param: 'store_in',
        type: 'model',
      },
    ],
  },
  panel: {
    Name: 'Panel',
    icon: 'border-style',
    description:
      'A visual container with a border to set content apart from the rest of the page.',
    cat: 'Layout',
    blacklist: [
      'key-write',
      'key-read',
      { type: 'courses', key: 'target_lms', value: 'blackboard_ultra' },
    ],
    settings: [
      {
        label: 'Title',
        param: 'heading',
        type: 'text',
      },
      {
        label: 'Translation',
        param: 'translation_key',
        type: 'translation_key',
      },
      {
        label: 'Transform Text',
        param: 'text_transform',
        type: 'select',
        options: {
          Default: '',
          Capitalize: 'capitalize',
          Uppercase: 'uppercase',
          Lowercase: 'lowercase',
        },
      },

      /*{
      label: "Footer",
      param: 'footer',
      type: "text"
    },*/
      {
        label: 'Hide title in LMS',
        param: 'hide_title',
        help: "You will still be able to see the title in scaffold, it just won't save into the lms",
        type: 'checkbox',
      },
      {
        label: 'Hide border in LMS',
        param: 'hide_border',
        help: "You will still be able to see the panel border in scaffold for formatting, it just won't save into the lms",
        type: 'checkbox',
      },
      /*, {
      label: "Panel Type",
      param: 'panel_type',
      type: "select",
      options: { "Default": "default", "Primary": "primary", "Warning": "warn" }
    }*/
    ],
  },
  well: {
    Name: 'Well',
    icon: 'minus-square',
    description:
      'A visual container with a darker background to set content apart from the rest of the page.',
    cat: 'Layout',
    blacklist: [
      'key-write',
      'key-read',
      { type: 'courses', key: 'target_lms', value: 'blackboard_ultra' },
    ],
    settings: [],
  },
  block_style: {
    Name: 'Block Styling',
    icon: 'square-full',
    description:
      "A visual container that allows for some custom styling to it and it's content.",
    cat: 'Layout',
    blacklist: [
      'key-write',
      'key-read',
      { type: 'courses', key: 'target_lms', value: 'blackboard_ultra' },
    ],
    settings: [
      {
        label: 'Background Styling',
        param: 'background_type',
        type: 'select',
        options: {
          Selected: 'select',
          'By Data': 'data',
          Manual: 'manual',
        },
      },
      {
        label: 'Background Color Param',
        param: 'name',
        type: 'model',
        if: [{ param: 'background_type', value: 'data' }],
      },
      {
        label: 'Background Color',
        param: 'background',
        type: 'background',
        if: [{ param: 'background_type', value: 'select' }],
      },
      {
        label: 'Background Color',
        param: 'background_color',
        type: 'color',
        help: 'Accepts hex code "#123456"',
        if: [{ param: 'background_type', value: 'manual' }],
      },
      {
        label: 'Border',
        param: 'border',
        type: 'text',
      },
      {
        label: 'Corner Radius',
        param: 'radius',
        type: 'number',
        help: "If you are syncing to Canvas, any value greater than 0 will give a generic courner rounding. Canvas doesn't allow setting the specific rounding amount.",
      },
      {
        label: 'Radius Type',
        param: 'radius_type',
        type: 'select',
        options: {
          Pixels: 'px',
          Percent: '%',
          'Relative to Text Size': 'em',
        },
      },
      {
        label: 'Align',
        param: 'alignment',
        type: 'select',
        options: {
          Center: 'align-center',
          Left: 'align-left',
          Right: 'align-right',
        },
      },
      {
        label: 'Padding Top & Bottom',
        param: 'padding_top_bottom',
        type: 'number',
      },
      {
        label: 'Padding Left & Right',
        param: 'padding_sides',
        type: 'number',
      },
      {
        label: 'Text Color',
        param: 'text_color',
        type: 'color',
      },
      {
        label: 'Italic',
        param: 'is_italic',
        type: 'checkbox',
      },
      {
        label: 'Bold',
        param: 'is_bold',
        type: 'checkbox',
      },
      {
        label: 'Width',
        param: 'width',
        type: 'text',
      },
      {
        label: 'Height',
        param: 'height',
        type: 'text',
      },
      {
        label: 'Custom Classes',
        param: 'classes',
        type: 'text',
        help: 'List of custom classes to apply to this component seperated by a space.',
      },
    ],
  },
  padding: {
    Name: 'Padded Container',
    icon: 'expand',
    description: 'A container that allows you to add padding around it.',
    cat: 'Layout',
    blacklist: [
      'key-write',
      'key-read',
      { type: 'courses', key: 'target_lms', value: 'blackboard_ultra' },
    ],
    settings: [
      {
        label: 'Left/Right Padding',
        param: 'left_right',
        type: 'number',
      },
      {
        label: 'Top/Bottom Padding',
        param: 'top_bottom',
        type: 'number',
      },
    ],
  },
  row: {
    Name: 'Columns',
    icon: 'columns',
    description:
      'A visual container that allows content to be split into multiple customizable columns.',
    cat: 'Layout',
    blacklist: [
      'key-write',
      'key-read',
      { type: 'courses', key: 'target_lms', value: 'blackboard_ultra' },
    ],
    settings: [
      {
        label: 'Column Widths',
        param: 'widths',
        countParam: 'content',
        type: 'column',
      },
      {
        label: 'Column',
        param: 'content',
        type: 'array_length',
        defaults: [],
      },
      {
        label: 'Vertical Align',
        param: 'vertical_align',
        type: 'select',
        options: {
          Top: 'top',
          Middle: 'middle',
          Bottom: 'bottom',
        },
      },
    ],
  },
  accordion: {
    Name: 'Accordion',
    icon: 'window-maximize',
    description:
      'An Accordion allows for an interactive container that separates content into multiple collapsible section vertically.',
    cat: 'Layout',
    blacklist: [
      'key-write',
      'key-read',
      { type: 'courses', key: 'target_lms', value: 'blackboard_ultra' },
    ],
    settings: [
      /*{
      label: "One at a Time",
      param: 'single',
      type: "checkbox"
    },*/ {
        label: 'Accordion',
        param: 'tabs',
        type: 'settings_array',
        settings: [
          {
            label: 'Heading',
            param: 'heading',
            type: 'text',
          },
          {
            label: 'Translation',
            param: 'translation_key',
            type: 'translation_key',
          },
          {
            label: 'Transform Text',
            param: 'text_transform',
            type: 'select',
            options: {
              Default: '',
              'Uppercase First Letter of Each Word': 'capitalize',
              'Uppercase Every Letter': 'uppercase',
            },
          },

          {
            label: 'Start Expanded',
            param: 'expanded',
            type: 'checkbox',
          },
        ],
        defaults: {
          heading: 'Heading',
          content: [],
        },
      },
      {
        label: 'Allow Multiple Panels Open',
        param: 'multiple',
        type: 'checkbox',
      },
    ],
  },
  tabs: {
    Name: 'Tabs',
    icon: 'newspaper',
    description:
      'An interactive container that separates content into multiple tabs horizontally.',
    cat: 'Layout',
    blacklist: [
      'key-write',
      'key-read',
      { type: 'courses', key: 'target_lms', value: 'blackboard_ultra' },
    ],
    settings: [
      {
        label: 'Tab',
        param: 'tabs',
        type: 'settings_array',
        settings: [
          {
            label: 'Tab Label',
            param: 'heading',
            type: 'text',
          },
          {
            label: 'Translation',
            param: 'translation_key',
            type: 'translation_key',
          },
          {
            label: 'Transform Text',
            param: 'text_transform',
            type: 'select',
            options: {
              Default: '',
              'Uppercase First Letter of Each Word': 'capitalize',
              'Uppercase Every Letter': 'uppercase',
            },
          },
        ],
        defaults: {
          heading: 'Heading',
          content: [],
        },
      },
      {
        label: 'Only Sync one tab',
        param: 'one_tab',
        type: 'checkbox',
      },
      {
        label: 'Tab index to sync',
        param: 'sync_tab',
        type: 'number',
        help: 'This is a 0 based index, so the first tab is index 0, the second is index 1 and so forth.',
        if: [{ param: 'one_tab', value: true }],
      },
    ],
  },
  flex: {
    Name: 'Flexible Columns',
    icon: 'columns',
    description: 'A container with coumns that resize based on content.',
    cat: 'Layout',
    blacklist: ['view', 'key-write', 'key-read'],
    settings: [
      {
        label: 'Column',
        param: 'content',
        type: 'settings_array',
        settings: [
          {
            type: 'help',
            text: 'Setting width weigth to 0 will allow width to be calculated based on the content of the column. A higher value will cause those columns to share the remaining width based on their respective weight.',
          },
          {
            label: 'Relative width weight',
            param: 'flex_width',
            type: 'select',
            options: {
              '0': 'flex-column-0',
              '1': 'flex-column-1',
              '2': 'flex-column-2',
              '3': 'flex-column-3',
              '4': 'flex-column-4',
            },
          },
          {
            label: 'Background Color',
            param: 'background',
            type: 'background',
          },
          {
            label: 'Background Gradient',
            param: 'gradient',
            type: 'checkbox',
          },
          {
            label: 'Collapsible',
            param: 'collapsible',
            type: 'checkbox',
          },
          {
            label: 'Icon',
            param: 'icon',
            type: 'icon',
          },
          {
            label: 'Color',
            param: 'color',
            type: 'color',
            if: [{ param: 'collapsible', value: true }],
          },
          {
            label: 'Tooltip',
            param: 'title',
            type: 'text',
          },
          {
            label: 'Translation',
            param: 'translation_key',
            type: 'translation_key',
          },
          {
            label: 'Transform Text',
            param: 'text_transform',
            type: 'select',
            options: {
              Default: '',
              'Uppercase First Letter of Each Word': 'capitalize',
              'Uppercase Every Letter': 'uppercase',
            },
          },
        ],
        defaults: {
          flex_width: 'flex-column-0',
          content: [],
        },
      },
      {
        label: 'Item Alignment',
        param: 'alignment',
        type: 'select',
        options: {
          top: 'flex-top',
          center: 'center',
          bottom: 'flex-bottom',
        },
      },
      {
        label: 'Fill Height of Outer Flex Column',
        param: 'fill_height',
        type: 'checkbox',
      },
    ],
  },
  create: {
    Name: 'Create Button',
    icon: 'plus-circle',
    description:
      'Adds a button to open the create dialog for a specified data type.',
    cat: 'Inputs',
    blacklist: ['view', 'key-write', 'key-read'],
    settings: [
      {
        label: 'Type',
        param: 'new_type',
        type: 'data_view',
      },
      {
        label: 'Button Label',
        param: 'heading',
        type: 'text',
      },
      {
        label: 'Translation for Label',
        param: 'translation_key_label',
        type: 'translation_key',
      },
      {
        label: 'Transform Text for Label',
        param: 'text_transform_label',
        type: 'select',
        options: {
          Default: '',
          Capitalize: 'capitalize',
          Uppercase: 'uppercase',
          Lowercase: 'lowercase',
        },
      },

      {
        label: 'Button Style',
        param: 'button_type',
        type: 'select',
        options: {
          Standard: '',
          Circular: 'circle',
          Text: 'ghost',
        },
      },

      {
        label: 'Modal Width Size',
        type: 'select',
        options: {
          Wide: 'wide',
          Half: 'half',
          Fit: 'fit',
        },
        param: 'modal_width_size',
      },
      {
        label: 'Use Icon for Button',
        param: 'use_icon',
        type: 'checkbox',
      },
      {
        label: 'Icon',
        param: 'icon',
        type: 'icon',
      },
      {
        label: 'Returned Id Param',
        param: 'param',
        type: 'model',
      },
      {
        label: 'Create as Link from Course',
        param: 'create_as_link',
        type: 'checkbox',
      },
      {
        label: 'Set Postion For Linked',
        param: 'set_position',
        type: 'checkbox',
        if: [{ param: 'create_as_link', value: true }],
      },
      {
        label: 'Create with default values',
        param: 'use_defaults',
        type: 'checkbox',
      },
      {
        label: 'Defaults',
        param: 'new_defaults',
        type: 'settings_array',
        settings: [
          {
            label: 'Key',
            param: 'key',
            type: 'model',
          },
          {
            label: 'Value',
            param: 'value',
            type: 'text',
          },
        ],
        defaults: {},
        if: [{ param: 'use_defaults', value: true }],
      },
    ],
  },
  gradebook: {
    Name: 'Grade Book',
    icon: 'columns',
    description:
      'A table display used to display a course gradebook. Used for Archiving.',
    cat: 'Layout',
    blacklist: ['view', 'key-write', 'key-read'],
    settings: [
      {
        label: 'Page Count',
        param: 'pageCounts',
        type: 'settings_array',
        settings: [
          {
            label: 'Count',
            param: 'count',
            type: 'number',
          },
        ],
        defaults: {
          count: 10,
        },
      },
      {
        label: 'Search Term',
        param: 'columns',
        type: 'settings_array',
        settings: [
          {
            label: 'Data Key',
            param: 'data',
            type: 'model',
            data_type: 'list_view',
          },
          {
            label: 'Label',
            param: 'label',
            type: 'text',
          },
          {
            label: 'Translation',
            param: 'translation_key',
            type: 'translation_key',
          },
          {
            label: 'Transform Text',
            param: 'text_transform',
            type: 'select',
            options: {
              Default: '',
              'Uppercase First Letter of Each Word': 'capitalize',
              'Uppercase Every Letter': 'uppercase',
            },
          },
        ],
        defaults: {
          label: 'Column',
        },
      },
    ],
  },
  list: {
    Name: 'List',
    icon: 'list',
    cat: 'Layout',
    description:
      'A cointainer that allows loading a list of data items in a specified mode.',
    blacklist: ['view', 'key-write', 'key-read'],
    settings: [
      {
        label: 'Types to load',
        param: 'list_view',
        type: 'settings_array',
        settings: [
          {
            label: 'Type',
            param: 'name',
            type: 'data_view',
          },
        ],
        defaults: {
          name: '',
        },
      },
      {
        label: 'Use Custom Add Button List',
        param: 'use_custom_buttons',
        type: 'checkbox',
        help: 'Specifiy custom button names to add data with specific parameters.',
      },

      {
        label: 'Custom Button List',
        param: 'custom_buttons',
        type: 'settings_array',
        if: [{ param: 'use_custom_buttons', value: true }],
        settings: [
          {
            label: 'Button Label',
            param: 'label',
            type: 'text',
          },
          {
            label: 'Type of Data to Add',
            param: 'type',
            type: 'data_view',
          },
          {
            label: 'Defaults',
            param: 'new_defaults',
            type: 'settings_array',
            settings: [
              {
                label: 'Key',
                param: 'key',
                type: 'model',
              },
              {
                label: 'Value',
                param: 'value',
                type: 'text',
              },
            ],
            defaults: {},
          },
        ],
        defaults: {},
      },
      {
        label: 'Mode',
        param: 'list_mode',
        type: 'other_mode',
        object_type: 'list_view',
      },
      {
        label: 'Load Recent Items',
        param: 'load_recent',
        type: 'checkbox',
      },
      {
        label: 'Recent Count',
        param: 'recent_count',
        type: 'number',
        if: [{ param: 'load_recent', value: true }],
      },

      {
        label: 'Display Active Item State Filter Dropdown',
        param: 'display_active_state_filter',
        type: 'checkbox',
      },

      {
        label: 'Force Only Active Items To Be Searched',
        param: 'force_only_active_items',
        type: 'checkbox',
      },
      {
        label: 'Filter Content',
        param: 'filter_content',
        type: 'checkbox',
      },
      {
        label: 'Parameter',
        param: 'param',
        type: 'text',
        if: [{ param: 'filter_content', value: true }],
      },
      {
        label: 'Filter Value Source',
        param: 'filter_source',
        type: 'select',
        if: [{ param: 'filter_content', value: true }],
        options: {
          Value: 'value',
          Parameter: 'parameter',
        },
      },
      {
        label: 'Value Parameter',
        param: 'name',
        type: 'model',
        if: [
          { param: 'filter_content', value: true },
          { param: 'filter_source', value: 'parameter' },
        ],
      },
      {
        label: 'Value',
        param: 'req_value',
        type: 'text',
        if: [
          { param: 'filter_content', value: true },
          { param: 'filter_source', not_value: 'parameter' },
        ],
      },
      {
        label: 'Hide border around list',
        param: 'hide_border',
        type: 'checkbox',
      },
      {
        label: 'Hide separator between items',
        param: 'hide_seperator',
        type: 'checkbox',
      },
      {
        label: 'Allow adding new items',
        param: 'allow_add',
        type: 'checkbox',
      },
      {
        label: 'Add button between item in list',
        param: 'add_between',
        type: 'checkbox',
        if: [{ param: 'allow_add', value: true }],
      },
      {
        label: 'Use Text Add Button Between Items',
        param: 'use_block_button',
        type: 'checkbox',
        if: [
          { param: 'allow_add', value: true },
          { param: 'add_between', value: true },
        ],
      },
      {
        label: 'Use icon for add button',
        param: 'use_icon',
        type: 'checkbox',
        if: [{ param: 'allow_add', value: true }],
      },
      {
        label: 'Add button label',
        param: 'button_title',
        type: 'text',
        if: [{ param: 'allow_add', value: true }],
      },
      {
        label: 'Display items horizontaly',
        param: 'is_horizontal',
        type: 'checkbox',
      },
      {
        label: 'Prevent wraping horizontal list',
        param: 'prevent_wrap',
        type: 'checkbox',
        if: [{ param: 'is_horizontal', value: true }],
      },
      {
        label: 'Number per line',
        param: 'column_count',
        type: 'number',
        if: [
          { param: 'is_horizontal', value: true },
          { param: 'prevent_wrap', value: false, not_defined: true },
        ],
      },
      {
        label: 'Inline creation form',
        param: 'inline_create',
        type: 'checkbox',
      },
      {
        label: 'Inline Create Mode',
        param: 'create_mode',
        type: 'text',
      },
      {
        label: 'Create with default values',
        param: 'use_defaults',
        type: 'checkbox',
      },
      {
        label: 'Defaults',
        param: 'new_defaults',
        type: 'settings_array',
        settings: [
          {
            label: 'Key',
            param: 'key',
            type: 'model',
          },
          {
            label: 'Value',
            param: 'value',
            type: 'text',
          },
        ],
        defaults: {},
        if: [{ param: 'use_defaults', value: true }],
      },
      {
        label: 'Delay Loading Items Until View is Rendered',
        param: 'delay_load',
        type: 'checkbox',
        help: `This will cause the itmes in this list to be loaded seperatly.
This will reduce the overall size of the initial view and speed up initial loading.
May cause slight delay of interactions while loading`,
      },
      {
        label: 'Wait for search after delayed load',
        param: 'search_load',
        type: 'checkbox',
        if: [{ param: 'delay_load', value: true }],
        help: `Items in this list will not be loaded until an active search is executed`,
      },
      {
        label: 'Get nested items',
        param: 'nested',
        type: 'checkbox',
      },
      {
        label: 'Display in Tabs',
        param: 'tab_view',
        type: 'checkbox',
      },
      {
        label: 'Allow saving',
        param: 'allow_save',
        type: 'checkbox',
      },
      {
        label: 'Allow sorting',
        param: 'allow_sort',
        type: 'checkbox',
      },
      {
        label: 'Context To Search',
        param: 'parent_context',
        type: 'select',
        options: {
          Self: 'self',
          'Parent Course': 'parent',
          'Specific Context': 'specified',
          'Entire Institution': 'all',
        },
      },
      {
        label: 'Specific Context Type',
        param: 'specified_type',
        type: 'data_view',
        if: [
          {
            param: 'parent_context',
            value: 'specified',
          },
        ],
      },
      {
        label: 'Specific Context Id Param',
        param: 'context_name',
        type: 'model',
        if: [{ param: 'parent_context', value: 'specified' }],
      },
      {
        label: 'Get All in Context',
        param: 'get_all',
        type: 'checkbox',
        help: 'If enabled, all children and sub-children will be returned, if not only direct children will be.',
      },
      {
        label: 'Allow Searching',
        param: 'allow_searching',
        type: 'checkbox',
      },
      {
        label: 'Search Term',
        param: 'columns',
        type: 'settings_array',
        if: [{ param: 'allow_searching', value: true }],
        settings: [
          {
            label: 'Data Key',
            param: 'data',
            type: 'model',
            data_type: 'list_view',
          },
          {
            label: 'Label',
            param: 'label',
            type: 'text',
          },
        ],
        defaults: {
          label: 'Column',
        },
      },
      {
        label: 'Paginate content',
        param: 'paginate_results',
        type: 'checkbox',
        if: [
          { param: 'load_more', not_value: true },
          { param: 'load_more', not_defined: true },
        ],
      },
      {
        label: 'Page Count',
        param: 'pageCounts',
        type: 'settings_array',
        if: [{ param: 'paginate_results', value: true }],
        settings: [
          {
            label: 'Count',
            param: 'count',
            type: 'number',
          },
        ],
        defaults: {
          count: 10,
        },
      },

      {
        label: 'Allow Load More',
        param: 'load_more',
        type: 'checkbox',
        if: [
          { param: 'paginate_results', not_value: true },
          { param: 'paginate_results', not_defined: true },
        ],
      },
    ],
  },
  list_card: {
    Name: 'Card List',
    icon: 'list-alt',
    cat: 'Layout',
    description:
      'A cointainer that allows loading a list of views in a horizontal expanding container.',
    blacklist: ['view', 'key-write', 'key-read'],
    settings: [
      {
        label: 'Card Label',
        param: 'card_label',
        type: 'text',
      },
      {
        label: 'Types to load',
        param: 'list_view',
        type: 'settings_array',
        settings: [
          {
            label: 'Type',
            param: 'name',
            type: 'data_view',
          },
        ],
        defaults: {
          name: '',
        },
      },
      {
        label: 'Parameter',
        param: 'param',
        type: 'text',
      },
      {
        label: 'Value',
        param: 'req_value',
        type: 'text',
      },
      {
        label: 'Add button label',
        param: 'button_title',
        type: 'text',
      },
      {
        label: 'Mode',
        param: 'list_mode',
        type: 'text',
      },
      {
        label: 'Icon',
        param: 'icon',
        type: 'icon',
      },
      {
        label: 'Allow adding new items',
        param: 'allow_add',
        type: 'checkbox',
      },
      {
        label: 'Allow saving',
        param: 'allow_save',
        type: 'checkbox',
      },
      {
        label: 'Create with default values',
        param: 'use_defaults',
        type: 'checkbox',
      },
      {
        label: 'Defaults',
        param: 'new_defaults',
        type: 'settings_array',
        settings: [
          {
            label: 'Key',
            param: 'key',
            type: 'model',
          },
          {
            label: 'Value',
            param: 'value',
            type: 'text',
          },
        ],
        defaults: {},
        if: [{ param: 'use_defaults', value: true }],
      },
    ],
  },
  general_card: {
    Name: 'Card with Content',
    icon: 'address-card',
    cat: 'Layout',
    description:
      'A cointainer that allows loading a view in the Index List component.',
    blacklist: ['view', 'key-write', 'key-read'],
    settings: [
      {
        label: 'Card Label',
        param: 'card_label',
        type: 'text',
      },
      {
        label: 'Icon',
        param: 'icon',
        type: 'icon',
      },
      {
        label: 'Allow saving',
        param: 'allow_save',
        type: 'checkbox',
      },
    ],
  },
  list_index: {
    Name: 'Index List',
    icon: 'grip-horizontal',
    cat: 'Layout',
    description:
      'A container that allows loading a list of views in a horizontal expanding container.',
    blacklist: ['view', 'key-write', 'key-read'],
    settings: [
      {
        label: 'Types to load',
        param: 'list_view',
        type: 'settings_array',
        settings: [
          {
            label: 'Type',
            param: 'name',
            type: 'data_view',
          },
        ],
        defaults: {
          name: '',
        },
      },
      {
        label: 'List Label',
        param: 'list_label',
        type: 'text',
      },
      {
        label: 'Translation for List Label',
        param: 'translation_key_list_label',
        type: 'translation_key',
      },
      {
        label: 'Transform Text for List Label',
        param: 'text_transform_list_label',
        type: 'select',
        options: {
          Default: '',
          Capitalize: 'capitalize',
          Uppercase: 'uppercase',
          Lowercase: 'lowercase',
        },
      },

      {
        label: 'Tab Label',
        param: 'tab_label',
        type: 'text',
      },
      {
        label: 'Translation for Tab Label',
        param: 'translation_key_tab_label',
        type: 'translation_key',
      },

      {
        label: 'Transform Text for Tab Label',
        param: 'text_transform_tab_label',
        type: 'select',
        options: {
          Default: '',
          Capitalize: 'capitalize',
          Uppercase: 'uppercase',
          Lowercase: 'lowercase',
        },
      },

      {
        label: 'Parameter',
        param: 'param',
        type: 'text',
      },
      {
        label: 'Value',
        param: 'req_value',
        type: 'text',
      },
      {
        label: 'Add button label',
        param: 'button_title',
        type: 'text',
      },
      {
        label: 'Advanced Order',
        param: 'adv_sort',
        type: 'settings_array',
        settings: [
          {
            label: 'Key',
            param: 'param',
            type: 'text',
          },
          {
            label: 'value',
            param: 'value',
            type: 'text',
          },
        ],
        defaults: {
          name: '',
        },
      },
      {
        label: 'Mode',
        param: 'list_mode',
        type: 'text',
      },
      {
        label: 'View Items in Tabs',
        param: 'tab_view',
        type: 'checkbox',
      },
      {
        label: 'Get nested items',
        param: 'nested',
        type: 'checkbox',
      } /*,{
        label: "Keep nested in root list",
        param: 'root_list',
        type: "checkbox"
      }*/,
      {
        label: 'Allow adding new items',
        param: 'allow_add',
        type: 'checkbox',
      },
      {
        label: 'Allow saving',
        param: 'allow_save',
        type: 'checkbox',
      },
      /*{
        label: "Allow sorting",
        param: 'allow_sort',
        type: "checkbox"
      }, {
        label: "Allow Linking Existing Items",
        param: 'allow_existing',
        type: "checkbox"
      }*/
    ],
  },
  connection: {
    Name: 'Connection',
    icon: 'network-wired',
    cat: 'Layout',
    description: 'Used to link an item to another item of a different type.',
    blacklist: ['view', 'key-write', 'key-read'],
    settings: [
      {
        label: 'Setting',
        param: 'name',
        type: 'model',
      },
      {
        label: 'Label',
        param: 'label',
        type: 'text',
      },
      {
        label: 'Translation',
        param: 'translation_key',
        type: 'translation_key',
      },
      {
        label: 'Transform Text',
        param: 'text_transform',
        type: 'select',
        options: {
          Default: '',
          Capitalize: 'capitalize',
          Uppercase: 'uppercase',
          Lowercase: 'lowercase',
        },
      },

      {
        label: 'Key to use for value',
        param: 'value_key',
        type: 'model',
        help: 'Select data key to use for value, defaults to id',
      },
      {
        label: 'Conected Type',
        param: 'allowed_types',
        type: 'settings_array',
        settings: [
          {
            label: 'Type',
            param: 'name',
            type: 'data_view',
          },
        ],
        defaults: {
          name: '',
        },
      },
      {
        label: 'Allow New',
        param: 'allow_new',
        type: 'checkbox',
      },
      {
        label: 'Global Items',
        param: 'global',
        type: 'checkbox',
      },
      {
        label: 'Same Instance',
        param: 'same_insatnce',
        type: 'checkbox',
        help: 'If a child insatnce of Scaffold is present, only display items from the current insatnce',
      },
      {
        label: 'Required',
        param: 'required',
        type: 'checkbox',
      },
    ],
  },
  feature_restriction: {
    Name: 'Feature Restriction',
    icon: 'question',
    cat: 'Layout',
    description: 'Used only in role views to restrict access to features.',
    blacklist: ['view', 'key-write', 'key-read'],
  },
  conditional: {
    Name: 'Conditional',
    icon: 'question',
    cat: 'Layout',
    description: 'Display sections based on data values.',
    blacklist: ['view', 'key-write', 'key-read'],
    settings: [
      {
        label: 'Data Key',
        param: 'name',
        type: 'model',
      },
      {
        label: 'Condition',
        param: 'condition',
        type: 'select',
        options: {
          Equal: 'equal',
          'Not Equal': 'notequal',
          'Greater-than': 'greater',
          'Less-than': 'less',
          Defined: 'defined',
          'Not Defined': 'notdefined',
          True: 'true',
          False: 'false',
          RegEx: 'regex',
          Length: 'length',
        },
      },
      {
        label: 'Length Comparison',
        param: 'length_comparison',
        type: 'select',
        options: {
          'Less Than': 'less',
          'Greater Than or Equal': 'greater',
        },
        if: [{ param: 'condition', value: 'length' }],
      },
      {
        label: 'Value',
        param: 'req_value',
        type: 'text',
      },
      {
        label: 'Static',
        param: 'static',
        type: 'checkbox',
      },
      {
        label: 'Comparison Name',
        param: 'req_name',
        type: 'model',
      },
    ],
  },
  role_conditional: {
    Name: 'Role Conditional',
    icon: 'question',
    cat: 'Layout',
    description: 'Display sections based on the users role.',
    blacklist: ['view', 'key-write', 'key-read'],
    settings: [
      {
        label: 'Roles',
        param: 'roles',
        type: 'settings_array',
        settings: [
          {
            label: 'Role',
            param: 'role',
            type: 'text',
          },
        ],
        defaults: {},
      },
      {
        label: 'Deny Users',
        param: 'denied',
        type: 'checkbox',
      },
    ],
  },
  feature_conditional: {
    Name: 'Feature Conditional',
    icon: 'question',
    cat: 'Layout',
    description: 'Display sections based on the users role.',
    blacklist: ['view', 'key-write', 'key-read'],
    settings: [
      {
        label: 'Features',
        param: 'features',
        type: 'settings_array',
        settings: [
          {
            label: 'Feature',
            param: 'feature',
            type: 'select',
            options: {
              Default: '',
              DataX: 'datax',
              'Archive V2': 'archivev2',
              'SIS Archive': 'sis-archive',
              'AI Detection': 'ai-detection',
              People: 'people',
              Imports: 'imports',
              Alerts: 'alerts',
              Courses: 'courses',
              Documentation: 'documentation',
              Lakehouse: 'lakehouse',
              Snowflake: 'snowflake',
              Analytics: 'analytics',
              Worksheets: 'worksheets',
            },
          },
        ],
        defaults: {},
      },
      {
        label: 'Deny Users',
        param: 'denied',
        type: 'checkbox',
      },
    ],
  },
  permission_conditional: {
    Name: 'Permission Conditional',
    icon: 'question',
    cat: 'Layout',
    description: 'Display sections based on the users permission.',
    blacklist: ['view', 'key-write', 'key-read'],
    settings: [
      {
        label: 'Permissions',
        param: 'permissions',
        type: 'settings_array',
        settings: [
          {
            label: 'Permission',
            param: 'permission',
            type: 'text',
          },
        ],
        defaults: {},
      },
      {
        label: 'Deny Users',
        param: 'denied',
        type: 'checkbox',
      },
    ],
  },
  upload: {
    Name: 'File Upload',
    icon: 'upload',
    description: 'File upload input.',
    cat: 'Inputs',
    blacklist: ['view', 'key-read'],
    settings: [
      {
        label: 'Use buttons for file interaction',
        param: 'use_buttons',
        type: 'checkbox',
      },
    ],
  },
  filebrowser: {
    Name: 'File Browser',
    icon: 'folder-open',
    description: 'File list and upload.',
    cat: 'Inputs',
    blacklist: ['view', 'key-write', 'key-read'],
    settings: [
      {
        label: 'Read Only',
        param: 'read_only',
        type: 'checkbox',
      },
      {
        label: 'Hide Global Tab',
        param: 'local_only',
        type: 'checkbox',
      },
    ],
  },
  wizard: {
    Name: 'Wizard',
    icon: 'hat-wizard',
    description:
      'Allows for creating a paginated walk-through for setting properties of an data item.',
    cat: 'Inputs',
    blacklist: ['view', 'key-write', 'key-read'],
    settings: [
      {
        label: 'Wizard Title',
        param: 'title',
        type: 'text',
      },
      {
        label: 'Translation',
        param: 'translation_key',
        type: 'translation_key',
      },
      {
        label: 'Transform Text',
        param: 'text_transform',
        type: 'select',
        options: {
          Default: '',
          Capitalize: 'capitalize',
          Uppercase: 'uppercase',
          Lowercase: 'lowercase',
        },
      },

      {
        label: 'Direction',
        param: 'direction',
        type: 'select',
        options: {
          Horizontal: 'horizontal',
          Vertical: 'vertical',
        },
      },
      {
        label: 'Use tab Styling',
        param: 'use_tab_style',
        type: 'checkbox',
        if: [{ param: 'direction', value: 'horizontal' }],
      },
      {
        label: 'Step',
        param: 'tabs',
        type: 'settings_array',
        settings: [
          {
            label: 'Step Label',
            param: 'heading',
            type: 'text',
          },
          {
            label: 'Translation for Step Label',
            param: 'translation_key_label',
            type: 'translation_key',
          },
          {
            label: 'Transform Text for Step Label',
            param: 'text_transform_label',
            type: 'select',
            options: {
              Default: '',
              'Uppercase First Letter of Each Word': 'capitalize',
              'Uppercase Every Letter': 'uppercase',
            },
          },
        ],
        defaults: {
          heading: 'Heading',
          content: [],
        },
      },
    ],
  },
  view: {
    Name: 'Open View',
    icon: 'binoculars',
    description: 'Adds a button that opens a set view in a modal dialog.',
    cat: 'Interaction',
    blacklist: ['view', 'key-write', 'key-read'],
    settings: [
      {
        label: 'Button Type',
        param: 'button_type',
        type: 'select',
        options: {
          'Text Button': 'text',
          'Right Menu Gear': 'gear',
        },
      },
      {
        label: 'Open Location',
        param: 'link_location',
        type: 'select',
        options: {
          'Main View': 'view',
          Dialog: 'modal',
        },
      },

      {
        label: 'Button Label',
        type: 'text',
        param: 'title',
      },

      ,
      {
        label: 'Translation',
        param: 'translation_key',
        type: 'translation_key',
      },
      {
        label: 'Transform Text',
        param: 'text_transform',
        type: 'select',
        options: {
          Default: '',
          Capitalize: 'capitalize',
          Uppercase: 'uppercase',
          Lowercase: 'lowercase',
        },
      },

      {
        label: 'Mode',
        param: 'view',
        type: 'data_mode',
      },
    ],
  },
  editor: {
    Name: 'Scaffold Editor',
    icon: 'pencil-ruler',
    description: 'Adds an editor area for creating content.',
    cat: 'Interaction',
    extendedHelp: 'Test',
    blacklist: ['view', 'key-read'],
    settings: [
      {
        label: 'Data Key',
        param: 'name',
        type: 'model',
      },
      {
        label: 'Scaffold mode',
        param: 'view',
        type: 'select',
        options: {
          Edit: 'edit',
          View: 'view',
        },
      },
      {
        label: 'Editor Title',
        param: 'title',
        type: 'text',
      },
      ,
      {
        label: 'Translation',
        param: 'translation_key',
        type: 'translation_key',
      },
      {
        label: 'Transform Text',
        param: 'text_transform',
        type: 'select',
        options: {
          Default: '',
          Capitalize: 'capitalize',
          Uppercase: 'uppercase',
          Lowercase: 'lowercase',
        },
      },

      {
        label: 'Text When Empty',
        param: 'text',
        type: 'text',
      },
      {
        label: 'Template',
        param: 'templates',
        type: 'settings_array',
        settings: [
          {
            label: 'Template Title',
            param: 'title',
            type: 'text',
          },
        ],
        defaults: {
          content: [],
        },
      },
      {
        label: 'Use first template for default content',
        param: 'first_default',
        type: 'checkbox',
        help: 'Use the content of the first template as the default cont',
      },
    ],
  },
  navigation: {
    Name: 'Navigation Frame',
    icon: 'compass',
    description: 'Adds a frame with custom navigation.',
    cat: 'Interaction',
    whitelist: ['root'],
    blacklist: ['view', 'key-write', 'key-read'],
    settings: [
      {
        label: 'Link',
        param: 'links',
        type: 'settings_array',
        settings: [
          {
            label: 'mode',
            param: 'link',
            type: 'text',
          },
          {
            label: 'Text',
            param: 'text',
            type: 'text',
          },
          ,
          {
            label: 'Translation',
            param: 'translation_key',
            type: 'translation_key',
          },
          {
            label: 'Transform Text',
            param: 'text_transform',
            type: 'select',
            options: {
              Default: '',
              'Uppercase First Letter of Each Word': 'capitalize',
              'Uppercase Every Letter': 'uppercase',
            },
          },
          {
            label: 'Icon',
            param: 'icon',
            type: 'icon',
          },
        ],
        defaults: {},
      },
      {
        label: 'Do not load course LTI',
        param: 'disable_lti',
        type: 'checkbox',
      },
      {
        label: 'Default Route',
        param: 'def_route',
        type: 'text',
      },
      {
        label: 'Content List Overide',
        param: 'route_overide',
        type: 'text',
        help: 'Overide pages/assignments/discussions/quizzes list views with a route for modules.',
      },
      {
        label: 'Avoid Displaying',
        param: 'hide',
        type: 'checkbox',
      },
    ],
  },
  link: {
    Name: 'Page Link',
    icon: 'link',
    description: 'A a link to a scaffold page.',
    cat: 'Interaction',
    blacklist: ['view', 'key-write', 'key-read'],

    settings: [
      {
        label: 'Link Type',
        param: 'link_type',
        type: 'select',
        options: {
          Text: '',
          Components: 'components',
        },
      },
      {
        label: 'Dispay value',
        param: 'name',
        type: 'model',
      },
      {
        label: 'Text',
        param: 'text',
        type: 'text',
      },

      ,
      {
        label: 'Translation',
        param: 'translation_key',
        type: 'translation_key',
      },
      {
        label: 'Transform Text',
        param: 'text_transform',
        type: 'select',
        options: {
          Default: '',
          Capitalize: 'capitalize',
          Uppercase: 'uppercase',
          Lowercase: 'lowercase',
        },
      },

      {
        label: 'Use Underline on Link',
        type: 'checkbox',
        param: 'use_underline',
      },
      {
        label: 'Target',
        param: 'link_target',
        type: 'select',
        options: {
          Self: 'edit',
          Child: 'child',
        },
      },
      {
        label: 'Open Location',
        param: 'link_location',
        type: 'select',
        options: {
          'Main View': 'view',
          Dialog: 'modal',
        },
      },
      {
        label: 'Modal Width Size',
        type: 'select',
        if: [{ param: 'link_location', value: 'modal' }],
        options: {
          Wide: 'wide',
          Half: 'half',
          Fit: 'fit',
        },
        param: 'modal_width_size',
      },
    ],
  },
  direct_link: {
    Name: 'Direct Link',
    icon: 'link',
    description: 'Adds a direct link to navigate with.',
    cat: 'Interaction',
    blacklist: ['view', 'key-write', 'key-read'],
    settings: [
      {
        label: 'Text',
        param: 'text',
        type: 'text',
      },
      {
        label: 'Translation',
        param: 'translation_key',
        type: 'translation_key',
      },
      {
        label: 'Transform Text',
        param: 'text_transform',
        type: 'select',
        options: {
          Default: '',
          Capitalize: 'capitalize',
          Uppercase: 'uppercase',
          Lowercase: 'lowercase',
        },
      },

      {
        label: 'link',
        param: 'link_target',
        type: 'text',
      },

      {
        label: 'Use Button for Link',
        type: 'checkbox',
        param: 'use_button',
      },
    ],
  },

  file_link: {
    Name: 'File Link',
    icon: 'link',
    description: 'Adds a link to a scaffold file.',
    cat: 'Interaction',
    blacklist: ['view', 'key-write', 'key-read'],
    settings: [
      {
        label: 'Dispay value',
        param: 'name',
        type: 'model',
      },
      {
        label: 'Text',
        param: 'text',
        type: 'text',
      },
      {
        label: 'Translation',
        param: 'translation_key',
        type: 'translation_key',
      },
      {
        label: 'Transform Text',
        param: 'text_transform',
        type: 'select',
        options: {
          Default: '',
          Capitalize: 'capitalize',
          Uppercase: 'uppercase',
          Lowercase: 'lowercase',
        },
      },

      {
        label: 'Target',
        param: 'link_target',
        type: 'select',
        options: {
          Self: 'edit',
          Child: 'child',
        },
      },
    ],
  },
  attachment: {
    Name: 'File',
    icon: 'paperclip',
    description: 'Attach a download link for a file.',
    cat: 'Content',
    blacklist: ['key-write', 'key-read'],
    settings: [
      {
        label: 'Text',
        param: 'text',
        type: 'text',
      },
      {
        label: 'Translation',
        param: 'translation_key',
        type: 'translation_key',
      },
      {
        label: 'Transform Text',
        param: 'text_transform',
        type: 'select',
        options: {
          Default: '',
          Capitalize: 'capitalize',
          Uppercase: 'uppercase',
          Lowercase: 'lowercase',
        },
      },

      {
        label: 'File',
        param: 'file',
        type: 'file',
      },
    ],
  },
  anchor: {
    Name: 'External Link',
    icon: 'globe',
    description: 'Adds a link to an external URL.',
    cat: 'Content',
    blacklist: ['key-write', 'key-read'],
    settings: [
      {
        label: 'Data for URL',
        param: 'link_url',
        type: 'settings_object',
        settings: [
          {
            label: 'Data Key',
            param: 'name',
            type: 'model',
          },
        ],
        defaults: {},
      },
      {
        label: 'Data for Link Text',
        param: 'link_text',
        type: 'settings_object',
        settings: [
          {
            label: 'Data Key',
            param: 'name',
            type: 'model',
          },
        ],
        defaults: {},
      },
      {
        label: 'Display Text',
        param: 'text',
        type: 'text',
      },

      {
        label: 'Translation',
        param: 'translation_key',
        type: 'translation_key',
      },
      {
        label: 'Transform Text',
        param: 'text_transform',
        type: 'select',
        options: {
          Default: '',
          Capitalize: 'capitalize',
          Uppercase: 'uppercase',
          Lowercase: 'lowercase',
        },
      },

      {
        label: 'URL',
        param: 'url',
        type: 'text',
      },
    ],
  },
  item_link: {
    Name: 'Link to Item',
    icon: 'link',
    description: 'Adds a link to another item in scaffold based on key values.',
    cat: 'Content',
    blacklist: ['view', 'key-write', 'key-read'],
    settings: [
      {
        label: 'Link Text',
        param: 'label',
        type: 'text',
      },
      ,
      {
        label: 'Translation',
        param: 'translation_key',
        type: 'translation_key',
      },
      {
        label: 'Transform Text',
        param: 'text_transform',
        type: 'select',
        options: {
          Default: '',
          Capitalize: 'capitalize',
          Uppercase: 'uppercase',
          Lowercase: 'lowercase',
        },
      },

      {
        label: 'Link Text Parameter',
        param: 'link_text',
        type: 'settings_object',
        settings: [
          {
            label: 'Data Key',
            param: 'name',
            type: 'model',
          },
        ],
        defaults: {},
      },
      {
        label: 'Link Type',
        param: 'set_type',
        type: 'text',
      },
      {
        label: 'Type Parameter',
        param: 'item_type',
        type: 'settings_object',
        settings: [
          {
            label: 'Data Key',
            param: 'name',
            type: 'model',
          },
        ],
        defaults: {},
      },
      {
        label: 'Id Parameter',
        param: 'item_id',
        type: 'settings_object',
        settings: [
          {
            label: 'Data Key',
            param: 'name',
            type: 'model',
          },
        ],
        defaults: {},
      },
      {
        label: 'Open Location',
        param: 'link_location',
        type: 'select',
        options: {
          'Main View': 'view',
          Dialog: 'modal',
        },
      },
    ],
  },
  integration: {
    Name: 'Integration',
    icon: 'puzzle-piece',
    description: 'Select an integration.',
    cat: 'Inputs',
    blacklist: ['view', 'key-read'],
    settings: [
      {
        label: 'Data Key',
        param: 'name',
        type: 'model',
      },
      {
        label: 'Label',
        param: 'label',
        type: 'text',
      },
      ,
      {
        label: 'Translation',
        param: 'translation_key',
        type: 'translation_key',
      },
      {
        label: 'Transform Text',
        param: 'text_transform',
        type: 'select',
        options: {
          Default: '',
          Capitalize: 'capitalize',
          Uppercase: 'uppercase',
          Lowercase: 'lowercase',
        },
      },

      {
        label: 'Integration type',
        param: 'integration_type',
        type: 'select',
        options: {
          'Learning Managment System': 'lms',
        },
      },
      {
        label: 'Filter Key',
        param: 'filter',
        type: 'settings_object',
        settings: [
          {
            label: 'Data Key',
            param: 'name',
            type: 'model',
          },
        ],
        defaults: {},
      },
    ],
  },
  menu: {
    Name: 'Data Menu',
    icon: 'bars',
    description: 'Adds a menu for interacting with a data item.',
    cat: 'Interaction',
    blacklist: ['view', 'key-write', 'key-read'],
    settings: [
      {
        label: 'Option',
        param: 'content',
        type: 'settings_array',
        settings: [
          {
            label: 'Label',
            param: 'text',
            type: 'text',
          },
          {
            label: 'Translation',
            param: 'translation_key',
            type: 'translation_key',
          },
          {
            label: 'Transform Text',
            param: 'text_transform',
            type: 'select',
            options: {
              Default: '',
              'Uppercase First Letter of Each Word': 'capitalize',
              'Uppercase Every Letter': 'uppercase',
            },
          },

          {
            label: 'Operation',
            param: 'operation',
            type: 'select',
            options: {
              View: 'openRead',
              Settings: 'openSettings',
              Duplicate: 'duplicateItem',
              Move: 'openMove',
              Preview: 'preview',
              Delete: 'deleteData',
              Export: 'export',
            },
          },
          {
            label: 'Use Referenced Item',
            param: 'use_referenced',
            type: 'checkbox',
            if: [{ param: 'operation', value: 'openRead' }],
          },
          {
            label: 'Use Referenced Item',
            param: 'use_referenced',
            type: 'checkbox',
            if: [{ param: 'operation', value: 'openSettings' }],
          },
          {
            label: 'Use Icon',
            param: 'use_icon',
            type: 'checkbox',
          } /*, {
            label: "Icon Catagory",
            param: 'catagory',
            type: "select",
            data: 'iconCatagories',
            dataLabel: 'title'
          }, {
            label: "Icon",
            param: 'icon',
            type: "select",
            data: 'iconCatagories.catagory',
            template: "<i class=\'{[label]}\'></i>",
            if: [{ param: "catagory", defined: true }]
          },*/,
          {
            label: 'Icon',
            param: 'icon',
            type: 'icon',
          },
          {
            label: 'Color',
            param: 'color',
            type: 'color',
          },
        ],
        defaults: {},
      },
      {
        label: 'Display as Button List',
        param: 'button_list',
        type: 'checkbox',
      },
    ],
  },
  learningcomponent: {
    Name: 'Learning Component',
    icon: 'box',
    description: 'Embeds Learning Component in the current view.',
    cat: 'Embeds',
    blacklist: ['key-write', 'key-read'],
    settings: [
      {
        label: 'Id',
        param: 'toload_id',
        toload_type: 'learningcomponent',
        type: 'data_search',
      },
      {
        label: 'Context To Search',
        param: 'parent_context',
        type: 'select',
        options: {
          'Parent Course': 'parent',
          'Entire Institution': 'all',
        },
      },
    ],
  },
  data: {
    Name: 'Data item',
    icon: 'database',
    description: 'Embeds a specified view of a data item in the layout.',
    cat: 'Embeds',
    blacklist: ['key-write', 'key-read'],
    settings: [
      {
        label: 'Data Param',
        param: 'name',
        type: 'model',
      },
      {
        label: 'Id',
        param: 'toload_id',
        type: 'data_search',
      },
      {
        label: 'Id to load',
        param: 'toload_id',
        type: 'text',
      },
      {
        label: 'Mode',
        param: 'toload_mode',
        type: 'other_mode',
        object_type: 'toload_type',
      },
      {
        label: 'Allow saving',
        param: 'allow_save',
        type: 'checkbox',
      },
    ],
  },
  bulk_input: {
    Name: 'CSV Input',
    icon: 'file-csv',
    description: 'Adds an input to import data from CSV.',
    cat: 'Inputs',
    blacklist: ['view', 'key-write', 'key-read'],
    settings: [
      {
        label: 'Instructions',
        param: 'instructions',
        type: 'text',
      },
      {
        label: 'Translation',
        param: 'translation_key',
        type: 'translation_key',
      },
      {
        label: 'Transform Text',
        param: 'text_transform',
        type: 'select',
        options: {
          Default: '',
          Capitalize: 'capitalize',
          Uppercase: 'uppercase',
          Lowercase: 'lowercase',
        },
      },

      {
        label: 'Type of Data',
        param: 'input_type',
        type: 'select',
        options: {
          'Create as Child Data Items': 'children',
          'Create Array of Data': 'array',
        },
      },
      {
        label: 'Child Type',
        param: 'create_type',
        type: 'data_view',
        if: [
          {
            param: 'input_type',
            value: 'children',
          },
        ],
      },
      {
        label: 'Array Param',
        param: 'array_param',
        type: 'model',
        if: [
          {
            param: 'input_type',
            value: 'array',
          },
        ],
      },
      {
        label: 'Column',
        param: 'columns',
        type: 'settings_array',
        settings: [
          {
            label: 'Data Key',
            param: 'data',
            type: 'model',
          },
          {
            label: 'Label',
            param: 'label',
            type: 'text',
          },
          {
            label: 'Sub Data Key',
            param: 'sub_key',
            type: 'model',
            data_type: 'data_view',
          },
          {
            label: 'Sub Column',
            param: 'columns',
            type: 'settings_array',
            settings: [
              {
                label: 'Data Key',
                param: 'data',
                type: 'model',
                data_type: 'data_view',
              },
              {
                label: 'Label',
                param: 'label',
                type: 'text',
              },
            ],
            defaults: {},
          },
        ],
        defaults: {},
        if: [
          {
            param: 'input_type',
            value: 'array',
          },
        ],
      },
      {
        label: 'Column',
        param: 'columns',
        type: 'settings_array',
        settings: [
          {
            label: 'Data Key',
            param: 'data',
            type: 'model',
          },
          {
            label: 'Label',
            param: 'label',
            type: 'text',
          },
          {
            label: 'Child Item Type',
            param: 'sub_key',
            type: 'data_view',
          },
          {
            label: 'Child Column',
            param: 'columns',
            type: 'settings_array',
            settings: [
              {
                label: 'Data Key',
                param: 'data',
                type: 'model',
                data_type: 'toload_type',
              },
              {
                label: 'Label',
                param: 'label',
                type: 'text',
              },
            ],
            defaults: {},
          },
        ],
        defaults: {},
        if: [
          {
            param: 'input_type',
            value: 'children',
          },
        ],
      },
    ],
  },
  data_search: {
    Name: 'Data Item Loader',
    icon: 'truck-loading',
    description:
      'Allows loading in a data item of a specific type with searching or by a data param.',
    cat: 'Interaction',
    blacklist: ['view', 'key-write', 'key-read'],
    settings: [
      {
        label: 'Data Param',
        param: 'name',
        type: 'model',
      },
      {
        label: 'Label',
        param: 'label',
        type: 'text',
      },
      {
        label: 'Translation',
        param: 'translation_key',
        type: 'translation_key',
      },
      {
        label: 'Transform Text',
        param: 'text_transform',
        type: 'select',
        options: {
          Default: '',
          Capitalize: 'capitalize',
          Uppercase: 'uppercase',
          Lowercase: 'lowercase',
        },
      },

      {
        label: 'Type',
        param: 'toload_type',
        type: 'data_view',
      },
      {
        label: 'Search Mode',
        param: 'search_mode',
        type: 'other_mode',
        object_type: 'toload_type',
      },
      {
        label: 'Display Mode',
        param: 'toload_mode',
        type: 'other_mode',
        object_type: 'toload_type',
      },
      {
        label: 'Allow Searching',
        param: 'allow_search',
        type: 'checkbox',
      },
      {
        label: 'Use Dynamic Headers For Modal Table',
        param: 'use_dynamic_headers',
        type: 'checkbox',
        help: 'Automatically generate column headers from data structure',
      },
      {
        label: 'Context To Search',
        param: 'parent_context',
        type: 'select',
        options: {
          'Parent Course': 'parent',
          'Specific Context': 'specified',
          'Entire Institution': 'all',
        },
      },
      {
        label: 'Specific Context Type',
        param: 'specified_type',
        type: 'data_view',
        if: [
          {
            param: 'parent_context',
            value: 'specified',
          },
        ],
      },
      {
        label: 'Specific Context Id Param',
        param: 'name',
        type: 'model',
        if: [{ param: 'parent_context', value: 'specified' }],
      },
    ],
  },
  data_link: {
    Name: 'Data Link List',
    icon: 'vector-square',
    description: 'Allows linking data item of a specific type.',
    cat: 'Interaction',
    blacklist: ['view', 'key-write', 'key-read'],
    settings: [
      {
        label: 'Type to Link',
        param: 'toload_type',
        type: 'data_view',
      },
      {
        label: 'Filter Parameter',
        param: 'param',
        type: 'text',
      },
      {
        label: 'Filter Value',
        param: 'req_value',
        type: 'text',
      },
      {
        label: 'Display Mode',
        param: 'toload_mode',
        type: 'other_mode',
        object_type: 'toload_type',
      },
      {
        label: 'Link Button Label',
        param: 'label',
        type: 'text',
      },
      ,
      {
        label: 'Translation for Button Label',
        param: 'translation_key_button_label',
        type: 'translation_key',
      },
      {
        label: 'Transform Text for Button Label',
        param: 'text_transform_button_label',
        type: 'select',
        options: {
          Default: '',
          Capitalize: 'capitalize',
          Uppercase: 'uppercase',
          Lowercase: 'lowercase',
        },
      },

      {
        label: 'Link Window Label',
        param: 'search_title',
        type: 'text',
      },
      {
        label: 'Translation for Window Label',
        param: 'translation_key_window_label',
        type: 'translation_key',
      },
      {
        label: 'Transform Text for Window Label',
        param: 'text_transform_window_label',
        type: 'select',
        options: {
          Default: '',
          Capitalize: 'capitalize',
          Uppercase: 'uppercase',
          Lowercase: 'lowercase',
        },
      },

      {
        label: 'Use Icon for Button',
        param: 'use_icon',
        type: 'checkbox',
      },
      {
        label: 'Button Icon',
        param: 'icon',
        type: 'icon',
        if: [{ param: 'use_icon', value: true }],
      },
      {
        label: 'Used Typed Link',
        param: 'type_link',
        type: 'checkbox',
        help: 'Create/Load link of a specified type',
      },
      {
        label: 'Link Type',
        param: 'type_link_value',
        type: 'text',
        if: [
          {
            param: 'type_link',
            value: true,
          },
        ],
      },
      {
        label: 'Use Headers',
        param: 'use_headers',
        type: 'checkbox',
      },

      {
        label: 'Headers',
        param: 'headers',
        type: 'settings_array',
        if: [{ param: 'use_headers', value: true }],
        settings: [
          {
            label: 'Header Text Value',
            param: 'header_text',
            type: 'text',
          },
          {
            label: 'Relative Header Width',
            param: 'header_width',
            type: 'select',
            options: {
              '0': 'flex-column-0',
              '1': 'flex-column-1',
              '2': 'flex-column-2',
              '3': 'flex-column-3',
              '4': 'flex-column-4',
            },
          },
        ],
        defaults: {
          label: 'Headers',
        },
      },
      {
        label: 'Use Dynamic Headers For Modal Table',
        param: 'use_dynamic_headers',
        type: 'checkbox',
        help: 'Automatically generate column headers from data structure',
      },
      {
        label: 'Text display if list is empty',
        param: 'empty_list',
        type: 'text',
      },
      {
        label: 'Display items in link window horizontaly',
        param: 'horizontal_list',
        type: 'checkbox',
      },
      {
        label: 'Link Window Item Mode',
        param: 'search_mode',
        type: 'other_mode',
        object_type: 'toload_type',
      },
      {
        label: 'Hide Search Functionality in Link List',
        param: 'hide_search',
        type: 'checkbox',
      },
      {
        label: 'Filter Results',
        param: 'filter_search',
        type: 'checkbox',
        if: [
          {
            param: 'hide_search',
            value: true,
          },
        ],
      },
      {
        label: 'Parameter',
        param: 'param',
        type: 'text',
        if: [
          {
            param: 'hide_search',
            value: true,
          },
          {
            param: 'filter_search',
            value: true,
          },
        ],
      },
      {
        label: 'Value',
        param: 'req_value',
        type: 'text',
        if: [
          {
            param: 'hide_search',
            value: true,
          },
          {
            param: 'filter_search',
            value: true,
          },
        ],
      },
      {
        label: 'Context of Link',
        param: 'link_context',
        type: 'select',
        options: {
          'Current Item': '',
          'Referenced Item': 'referenced',
          User: 'user',
        },
      },
      {
        label: 'Context To Search',
        param: 'parent_context',
        type: 'select',
        options: {
          'Parent Course': 'parent',
          'Specific Context': 'specified',
          'Entire Institution': 'all',
        },
      },
      {
        label: 'Get All in Context',
        param: 'get_all',
        type: 'checkbox',
        help: 'If enabled, all children and sub-children will be returned, if not only direct children will be.',
        if: [
          {
            param: 'parent_context',
            value: 'parent',
          },
        ],
      },
      {
        label: 'Specific Context Type',
        param: 'specified_type',
        type: 'data_view',
        if: [
          {
            param: 'parent_context',
            value: 'specified',
          },
        ],
      },
      {
        label: 'Set Postion',
        param: 'set_position',
        type: 'checkbox',
      },
      {
        label: 'Specific Context Id Param',
        param: 'name',
        type: 'model',
        if: [{ param: 'parent_context', value: 'specified' }],
      },
      {
        label: 'Prevent Creating New Items from Link List',
        param: 'prevent_create',
        type: 'checkbox',
      },
      {
        label: 'Prevent Linking in This List',
        param: 'prevent_add',
        type: 'checkbox',
      },
      {
        label: 'Display items horizontaly with wrap',
        param: 'is_horizontal',
        type: 'checkbox',
      },
      {
        label: 'Separator',
        param: 'list_seperator',
        type: 'text',
        if: [{ param: 'is_horizontal', value: true }],
      },
      {
        label: 'Prevent wraping horizontal list',
        param: 'prevent_wrap',
        type: 'checkbox',
        if: [{ param: 'is_horizontal', value: true }],
      },
      {
        label: 'Fill Height of Outer Flex Column',
        param: 'fill_height',
        type: 'checkbox',
        if: [{ param: 'is_horizontal', value: true }],
      },
      {
        label: 'Allow Searching',
        param: 'allow_searching',
        type: 'checkbox',
      },
      {
        label: 'Search Term',
        param: 'columns',
        type: 'settings_array',
        if: [{ param: 'allow_searching', value: true }],
        settings: [
          {
            label: 'Data Key',
            param: 'data',
            type: 'model',
            data_type: 'list_view',
          },
          {
            label: 'Label',
            param: 'label',
            type: 'text',
          },
        ],
        defaults: {
          label: 'Column',
        },
      },
      {
        label: 'Page Count',
        param: 'pageCounts',
        type: 'settings_array',
        if: [{ param: 'allow_searching', value: true }],
        settings: [
          {
            label: 'Count',
            param: 'count',
            type: 'number',
          },
        ],
        defaults: {
          count: 10,
        },
      },
      {
        label: 'Paginate content',
        param: 'paginate_results',
        type: 'checkbox',
      },
    ],
  },
  data_link_count: {
    Name: 'Data Link Count',
    icon: 'hashtag',
    description:
      'Displays link count and allows linking data item of a specific type.',
    cat: 'Interaction',
    blacklist: ['view', 'key-write', 'key-read'],
    settings: [
      {
        label: 'Type',
        param: 'toload_type',
        type: 'data_view',
      },
      {
        label: 'Filter Parameter',
        param: 'param',
        type: 'text',
      },
      {
        label: 'Filter Value',
        param: 'req_value',
        type: 'text',
      },
      {
        label: 'Allow Linking',
        param: 'allow_link',
        type: 'checkbox',
      },
      {
        label: 'Link Window Item Mode',
        param: 'search_mode',
        type: 'other_mode',
        object_type: 'toload_type',
      },
      {
        label: 'Search Label',
        param: 'search_title',
        type: 'text',
      },

      {
        label: 'Translation',
        param: 'translation_key',
        type: 'translation_key',
      },
      {
        label: 'Transform Text',
        param: 'text_transform',
        type: 'select',
        options: {
          Default: '',
          Capitalize: 'capitalize',
          Uppercase: 'uppercase',
          Lowercase: 'lowercase',
        },
      },
      {
        label: 'Use Dynamic Headers For Modal Table',
        param: 'use_dynamic_headers',
        type: 'checkbox',
        help: 'Automatically generate column headers from data structure',
      },

      {
        label: 'Used Typed Link',
        param: 'type_link',
        type: 'checkbox',
        help: 'Create/Load link of a specified type',
      },
      {
        label: 'Link Type',
        param: 'type_link_value',
        type: 'text',
        if: [
          {
            param: 'type_link',
            value: true,
          },
        ],
      },
      {
        label: 'Display Items in Link List horizontaly',
        param: 'horizontal_list',
        type: 'checkbox',
      },
      {
        label: 'Hide Search Functionality in Link List',
        param: 'hide_search',
        type: 'checkbox',
      },
      {
        label: 'Filter Results',
        param: 'filter_search',
        type: 'checkbox',
        if: [
          {
            param: 'hide_search',
            value: true,
          },
        ],
      },
      {
        label: 'Parameter',
        param: 'param',
        type: 'text',
        if: [
          {
            param: 'hide_search',
            value: true,
          },
          {
            param: 'filter_search',
            value: true,
          },
        ],
      },
      {
        label: 'Value',
        param: 'req_value',
        type: 'text',
        if: [
          {
            param: 'hide_search',
            value: true,
          },
          {
            param: 'filter_search',
            value: true,
          },
        ],
      },
      {
        label: 'Context To Search',
        param: 'parent_context',
        type: 'select',
        options: {
          'Parent Course': 'parent',
          'Specific Context': 'specified',
          'Entire Institution': 'all',
        },
      },
      {
        label: 'Get All in Context',
        param: 'get_all',
        type: 'checkbox',
        help: 'If enabled, all children and sub-children will be returned, if not only direct children will be.',
        if: [
          {
            param: 'parent_context',
            value: 'parent',
          },
        ],
      },
      {
        label: 'Specific Context Type',
        param: 'specified_type',
        type: 'data_view',
        if: [
          {
            param: 'parent_context',
            value: 'specified',
          },
        ],
      },
      {
        label: 'Specific Context Id Param',
        param: 'name',
        type: 'model',
        if: [{ param: 'parent_context', value: 'specified' }],
      },
      {
        label: 'Prevent Creating New Items from Link List',
        param: 'prevent_create',
        type: 'checkbox',
      },
    ],
  },
  data_link_label: {
    Name: 'Data Link Label List',
    icon: 'tags',
    description:
      'Displays linked items of a specified type as a horizontal or vertical label.',
    cat: 'Interaction',
    blacklist: ['view', 'key-write', 'key-read'],
    settings: [
      {
        label: 'Type to Link',
        param: 'toload_type',
        type: 'data_view',
      },
      {
        label: 'Link Tooltip',
        param: 'label',
        type: 'text',
      },
      {
        label: 'Translation for Tooltip',
        param: 'translation_key_tooltip',
        type: 'translation_key',
      },
      {
        label: 'Transform Text for Tooltip',
        param: 'text_transform_tooltip',
        type: 'select',
        options: {
          Default: '',
          Capitalize: 'capitalize',
          Uppercase: 'uppercase',
          Lowercase: 'lowercase',
        },
      },

      {
        label: 'Filter Parameter',
        param: 'param',
        type: 'text',
      },
      {
        label: 'Filter Value',
        param: 'req_value',
        type: 'text',
      },
      {
        label: 'Display Mode',
        param: 'toload_mode',
        type: 'other_mode',
        object_type: 'toload_type',
      },
      {
        label: 'Link Window Label',
        param: 'search_title',
        type: 'text',
      },
      {
        label: 'Translation',
        param: 'translation_key',
        type: 'translation_key',
      },
      {
        label: 'Transform Text',
        param: 'text_transform',
        type: 'select',
        options: {
          Default: '',
          Capitalize: 'capitalize',
          Uppercase: 'uppercase',
          Lowercase: 'lowercase',
        },
      },
      {
        label: 'Use Dynamic Headers For Modal Table',
        param: 'use_dynamic_headers',
        type: 'checkbox',
        help: 'Automatically generate column headers from data structure',
      },

      {
        label: 'Link Window Mode',
        param: 'search_mode',
        type: 'other_mode',
        object_type: 'toload_type',
      },
      {
        label: 'Used Typed Link',
        param: 'type_link',
        type: 'checkbox',
        help: 'Create/Load link of a specified type',
      },
      {
        label: 'Link Type',
        param: 'type_link_value',
        type: 'text',
        if: [
          {
            param: 'type_link',
            value: true,
          },
        ],
      },
      {
        label: 'Display Items in Link List horizontaly',
        param: 'horizontal_list',
        type: 'checkbox',
      },
      {
        label: 'Hide Search Functionality in Link Window',
        param: 'hide_search',
        type: 'checkbox',
      },
      {
        label: 'Filter Results',
        param: 'filter_search',
        type: 'checkbox',
        if: [
          {
            param: 'hide_search',
            value: true,
          },
        ],
      },
      {
        label: 'Parameter',
        param: 'param',
        type: 'text',
        if: [
          {
            param: 'hide_search',
            value: true,
          },
          {
            param: 'filter_search',
            value: true,
          },
        ],
      },
      {
        label: 'Value',
        param: 'req_value',
        type: 'text',
        if: [
          {
            param: 'hide_search',
            value: true,
          },
          {
            param: 'filter_search',
            value: true,
          },
        ],
      },
      {
        label: 'Context To Search',
        param: 'parent_context',
        type: 'select',
        options: {
          'Parent Course': 'parent',
          'Specific Context': 'specified',
          'Entire Institution': 'all',
        },
      },
      {
        label: 'Get All in Context',
        param: 'get_all',
        type: 'checkbox',
        help: 'If enabled, all children and sub-children will be returned, if not only direct children will be.',
        if: [
          {
            param: 'parent_context',
            value: 'parent',
          },
        ],
      },
      {
        label: 'Specific Context Type',
        param: 'specified_type',
        type: 'data_view',
        if: [
          {
            param: 'parent_context',
            value: 'specified',
          },
        ],
      },
      {
        label: 'Specific Context Id Param',
        param: 'name',
        type: 'model',
        if: [{ param: 'parent_context', value: 'specified' }],
      },
      {
        label: 'Prevent Creating New Items from Link List',
        param: 'prevent_create',
        type: 'checkbox',
      },
      {
        label: 'Display items horizontaly with wrap',
        param: 'is_horizontal',
        type: 'checkbox',
      },
      {
        label: 'Separator',
        param: 'list_seperator',
        type: 'text',
        if: [{ param: 'is_horizontal', value: true }],
      },
      {
        label: 'Prevent wraping horizontal list',
        param: 'prevent_wrap',
        type: 'checkbox',
        if: [{ param: 'is_horizontal', value: true }],
      },
      {
        label: 'Fill Height of Outer Flex Column',
        param: 'fill_height',
        type: 'checkbox',
        if: [{ param: 'is_horizontal', value: true }],
      },
    ],
  },
  text_link_label: {
    Name: 'Text Link Label List',
    icon: 'tags',
    description:
      'Displays linked items of a specified type as a horizontal or vertical label.',
    cat: 'Interaction',
    blacklist: ['view', 'key-write', 'key-read'],
    settings: [
      {
        label: 'Heading Display',
        param: 'display_type',
        type: 'select',
        options: {
          'Plain Text': 'p',
          'Heading 1': 'h1',
          'Heading 2': 'h2',
          'Heading 3': 'h3',
          'Heading 4': 'h4',
          'Heading 5': 'h5',
          'Heading 6': 'h6',
        },
      },
      {
        label: 'Display Content',
        param: 'name',
        type: 'text',
        help: 'Can contain text, user [brackets] around keys to load data',
      },
      {
        label: 'Translation',
        param: 'translation_key',
        type: 'translation_key',
      },
      {
        label: 'Transform Text',
        param: 'text_transform',
        type: 'select',
        options: {
          Default: '',
          Capitalize: 'capitalize',
          Uppercase: 'uppercase',
          Lowercase: 'lowercase',
        },
      },
      {
        label: 'Type to Link',
        param: 'toload_type',
        type: 'data_view',
      },
      {
        label: 'List Prefix',
        param: 'prefix',
        type: 'text',
      },
      {
        label: 'Separator',
        param: 'seperator',
        type: 'text',
      },
      {
        label: 'List Sufix',
        param: 'sufix',
        type: 'text',
      },
      {
        label: 'Separator',
        param: 'list_seperator',
        type: 'text',
        if: [{ param: 'is_horizontal', value: true }],
      },
      {
        label: 'Context of Link',
        param: 'link_context',
        type: 'select',
        options: {
          'Current Item': '',
          'Referenced Item': 'referenced',
          User: 'user',
        },
      },
    ],
  },

  data_array: {
    Name: 'Data Form Array',
    icon: 'layer-group',
    description: 'Allows linking data item of a specific type.',
    cat: 'Interaction',
    blacklist: ['view', 'key-write', 'key-read'],
    settings: [
      {
        label: 'Data Param',
        param: 'name',
        type: 'model',
      },
      {
        label: 'Button Label',
        param: 'add_label',
        type: 'text',
      },
      ,
      {
        label: 'Translation',
        param: 'translation_key',
        type: 'translation_key',
      },
      {
        label: 'Transform Text',
        param: 'text_transform',
        type: 'select',
        options: {
          Default: '',
          Capitalize: 'capitalize',
          Uppercase: 'uppercase',
          Lowercase: 'lowercase',
        },
      },

      {
        label: 'Button Alignment',
        param: 'alignment',
        type: 'select',
        options: {
          Center: 'align-center',
          Left: 'align-left',
          Right: 'align-right',
        },
      },
      {
        label: 'Button Style',
        param: 'button_type',
        type: 'select',
        options: {
          Standard: '',
          Circular: 'circle',
          Text: 'ghost',
        },
      },
      {
        label: 'Use Icon for Button',
        param: 'use_icon',
        type: 'checkbox',
      },
      {
        label: 'Button Icon',
        param: 'icon',
        type: 'icon',
        if: [{ param: 'use_icon', value: true }],
      },
      {
        label: 'Use In-line Button',
        param: 'use_inline',
        type: 'checkbox',
      },
      {
        label: 'Prevent adding or removing items in this view',
        param: 'prevent_edit',
        type: 'checkbox',
      },
      {
        label: 'Display items horizontaly with wrap',
        param: 'is_horizontal',
        type: 'checkbox',
      },
      {
        label: 'Prevent wraping horizontal list',
        param: 'prevent_wrap',
        type: 'checkbox',
        if: [{ param: 'is_horizontal', value: true }],
      },
    ],
  },
  template_data_array: {
    Name: 'Data Array From Text Template',
    icon: 'clone',
    description: 'Allows linking data item to a bracketed text template.',
    cat: 'Interaction',
    blacklist: ['view', 'key-write', 'key-read'],
    settings: [
      {
        label: 'Template Data Key',
        param: 'name',
        type: 'model',
      },
      {
        label: 'Out Array Data Key',
        param: 'out_name',
        type: 'model',
      },
      {
        label: 'Key for Data Index',
        param: 'index_key',
        type: 'model',
      },
    ],
  },
  data_visuals: {
    Name: 'Chart',
    icon: 'chart-pie',
    description: 'Chart display of data.',
    cat: 'Embeds',
    blacklist: ['view', 'key-write', 'key-read'],
    settings: [
      {
        label: 'Data Point',
        param: 'data_items',
        type: 'settings_array',
        settings: [
          {
            label: 'Data Key',
            param: 'name',
            type: 'model',
          },
          {
            label: 'Label',
            param: 'label',
            type: 'text',
          },
          {
            label: 'Color',
            param: 'color',
            type: 'color',
            help: 'Accepts hex code "#123456"',
          },
        ],
        defaults: {},
      },
      {
        label: 'Value Label Display',
        param: 'value_display',
        type: 'select',
        options: {
          'Show Value': 'value',
          'Show Percent': 'percent',
          None: null,
        },
      },
      {
        label: 'Inner Radius for Donut in Percent',
        param: 'innerRadius',
        type: 'number',
      },
      {
        label: 'Show Total in Center',
        param: 'showTotal',
        type: 'checkbox',
      },
    ],
  },
  custom: {
    Name: 'Custom HTML Template',
    icon: 'chess',
    description: 'Insert custom template item.',
    cat: 'Content',
    blacklist: ['view', 'key-write', 'key-read'],
    settings: [
      {
        text: 'Use the HTML block below to define your template. You can add variable substitution with the syntax: {{variable}}. Variable can be used multiple time in the template.',
        type: 'help',
      },
      {
        label: 'HTML',
        param: 'html',
        type: 'text',
      },
      {
        label: 'Title',
        param: 'title',
        type: 'textparam',
      },
      {
        label: 'Item 1',
        param: 'item1',
        type: 'textparam',
      },
      {
        label: 'Item 2',
        param: 'item2',
        type: 'textparam',
      },
      {
        label: 'Item 3',
        param: 'item3',
        type: 'textparam',
      },
    ],
  },
  phone_number: {
    Name: 'Phone Number',
    icon: 'phone',
    description: 'Formatted phone number.',
    cat: 'Inputs',
    blacklist: ['view', 'key-read'],
    settings: [
      {
        label: 'Data Key',
        param: 'name',
        type: 'model',
      },
      {
        label: 'Label',
        param: 'label',
        type: 'text',
      },
      ,
      {
        label: 'Translation',
        param: 'translation_key',
        type: 'translation_key',
      },
      {
        label: 'Transform Text',
        param: 'text_transform',
        type: 'select',
        options: {
          Default: '',
          Capitalize: 'capitalize',
          Uppercase: 'uppercase',
          Lowercase: 'lowercase',
        },
      },
    ],
  },
  lti_tool: {
    Name: 'LTI Tool',
    icon: 'toolbox',
    description: 'Adds LTI tool for launch.',
    cat: 'Embeds',
    blacklist: ['view', 'key-read'],
    settings: [
      {
        label: 'Data Key',
        param: 'name',
        type: 'model',
      },
    ],
  },
  comment_filter: {
    Name: 'Comment Filter',
    icon: 'comment-slash',
    description: 'Adds a filter for user comments.',
    cat: 'Inputs',
    blacklist: ['view', 'key-read', 'key-write'],
    settings: [],
  },
  comment_list: {
    Name: 'Comment List',
    icon: 'comments',
    description: 'List of all comment for this data item.',
    cat: 'Inputs',
    blacklist: ['view', 'key-read', 'key-write'],
    settings: [
      {
        label: 'Comment Reference',
        param: 'reference',
        type: 'select',
        options: {
          Self: 'self',
          Referenced: 'referenced_id',
        },
      },
    ],
  },
  settings_panel: {
    Name: 'Setting Panel Content',
    icon: 'cogs',
    description:
      'Adds a button that opens a side panel that can contain inputs and other components.',
    cat: 'Inputs',
    blacklist: ['view', 'key-read', 'key-write'],
    settings: [
      {
        label: 'Page Button Label',
        param: 'button_label',
        type: 'text',
      },
      ,
      {
        label: 'Translation for Page Button',
        param: 'translation_key_page_button',
        type: 'translation_key',
      },
      {
        label: 'Transform Text for Page Button',
        param: 'text_transform_page_button',
        type: 'select',
        options: {
          Default: '',
          Capitalize: 'capitalize',
          Uppercase: 'uppercase',
          Lowercase: 'lowercase',
        },
      },

      {
        label: 'Show Settings Icon',
        param: 'use_icon',
        type: 'checkbox',
      },
      {
        label: 'Icon',
        param: 'icon',
        type: 'icon',
        if: [{ param: 'use_icon', value: true }],
      },
      {
        label: 'Panel Heading',
        param: 'panel_title',
        type: 'text',
      },
      {
        label: 'Translation for Heading',
        param: 'translation_key_heading',
        type: 'translation_key',
      },
      {
        label: 'Transform Text for Heading',
        param: 'text_transform_heading',
        type: 'select',
        options: {
          Default: '',
          Capitalize: 'capitalize',
          Uppercase: 'uppercase',
          Lowercase: 'lowercase',
        },
      },
    ],
  },
  up_next: {
    Name: 'Up Next List',
    description:
      'Adds a button that opens a side panel that can contain inputs and other components.',
    cat: 'User Content',
    blacklist: ['view', 'key-read', 'key-write'],
    settings: [],
  },
  mentions: {
    Name: 'Latest Mentions',
    description:
      'Adds a button that opens a side panel that can contain inputs and other components.',
    cat: 'User Content',
    blacklist: ['view', 'key-read', 'key-write'],
    settings: [],
  },
  scaffold_json: {
    Name: 'JSON Viewer',
    description: 'Allows direct access to json_data for a data item.',
    cat: 'Inputs',
    blacklist: ['view', 'key-read', 'key-write'],
    settings: [],
  },
  user_instance_select: {
    Name: 'User Instance Select',
    description:
      'Allows selecting instances for a user in a multi-product ebvironment',
    cat: 'Inputs',
    blacklist: ['view', 'key-read', 'key-write'],
    settings: [
      {
        label: 'Label',
        param: 'label',
        type: 'text',
        defaults: {
          label: 'Role',
        },
      },
    ],
  },
  rubric: {
    Name: 'Rubric',
    description: 'Display rubrics in a formatted view.',
    cat: 'Inputs',
    blacklist: ['view', 'key-read', 'key-write'],
    settings: [],
  },
  integration_status: {
    Name: 'Integration Status',
    description: 'Display integration status.',
    cat: 'Inputs',
    blacklist: ['view', 'key-read', 'key-write'],
    settings: [],
  },
  datax_role_select: {
    Name: 'DataX Role Select',
    icon: 'hand-pointer',
    description:
      'A dropdown for selecting DataX roles with customizable options.',
    cat: 'Inputs',
    blacklist: ['view', 'key-read'],
    settings: [
      {
        label: 'Data Key',
        param: 'name',
        type: 'model',
      },
      {
        label: 'Label',
        param: 'label',
        type: 'text',
      },
      {
        label: 'Translation for Label',
        param: 'translation_key_label',
        type: 'translation_key',
      },
      {
        label: 'Transform Text for Label',
        param: 'text_transform_label',
        type: 'select',
        options: {
          Default: '',
          Capitalize: 'capitalize',
          Uppercase: 'uppercase',
          Lowercase: 'lowercase',
        },
      },
      {
        label: 'Placeholder Text',
        param: 'placeholder',
        type: 'text',
      },
      {
        label: 'Translation for Placeholder',
        param: 'translation_key_placeholder',
        type: 'translation_key',
      },
      {
        label: 'Transform Text for Placeholder',
        param: 'text_transform_placeholder',
        type: 'select',
        options: {
          Default: '',
          Capitalize: 'capitalize',
          Uppercase: 'uppercase',
          Lowercase: 'lowercase',
        },
      },
      {
        label: 'Option',
        param: 'options',
        type: 'settings_array',
        settings: [
          {
            label: 'Label',
            param: 'label',
            type: 'text',
          },
          {
            label: 'Translation for Label',
            param: 'translation_key_label',
            type: 'translation_key',
          },
          {
            label: 'Transform Text for Label',
            param: 'text_transform_label',
            type: 'select',
            options: {
              Default: '',
              'Uppercase First Letter of Each Word': 'capitalize',
              'Uppercase Every Letter': 'uppercase',
            },
          },
          {
            label: 'Value',
            param: 'value',
            type: 'text',
          },
        ],
        defaults: {
          heading: 'Option',
        },
      },
      {
        label: 'Help Text',
        param: 'helpText',
        type: 'text',
      },
      {
        label: 'Translation for Help Text',
        param: 'translation_key_help_text',
        type: 'translation_key',
      },
      {
        label: 'Transform Text for Help Text',
        param: 'text_transform_help_text',
        type: 'select',
        options: {
          Default: '',
          Capitalize: 'capitalize',
          Uppercase: 'uppercase',
          Lowercase: 'lowercase',
        },
      },
      {
        label: 'Required',
        param: 'required',
        type: 'checkbox',
      },
    ],
  },
  hide_save_component: {
    Name: 'Hide Save Button',
    icon: 'cogs',
    description:
      'When added to a view, this component will hide the save button. Useful for views that handle their own saving logic.',
    cat: 'Layout',
    blacklist: ['view', 'key-read', 'key-write'],
    settings: [],
  },
};
